// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/common/icons/GROUP-24.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/common/icons/PERSON-24.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/common/icons/ROLE-24.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../images/common/icons/EVERYBODY-24.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../images/loadingIndicator.gif", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../images/common/icons/icon_Search.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../images/common/icons/calendar-filter.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,300,500,700,900);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:400,300,500,700,900);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Bootstrap Override*/
@media (min-width: 1200px) {
	nav .container, header .container {
		width: 100%;
	}

	.right-nav {
		display: none;
	}
}

@media (max-width: 768px) {
	.navbar-default .navbar-nav .open .dropdown-menu>li>a, .navbar-default .navbar-nav .open .dropdown-menu>li>a:hover {
		color: #fff;
	}

	.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover {
		background: #c72328;
	}

	.navbar-default .navbar-nav .open .dropdown-toggle {
		width: 100%;
	}

	.navbar-default .navbar-nav .open {
		border-bottom: 1px solid #c72328;
	}

	.dashboard-left-rail {
		width: 240px !important;
	}

	.content-wrap {
		margin-left: 240px !important;
		width: calc(100vw - 240px) !important;
	}

	.ai-panel-open .content-wrap {
		width: calc(100vw - 240px - 380px) !important;
	}

	.action-buttons .pull-left, .action-buttons .pull-right {
		float: none !important;
	}
	.action-buttons .btn, .action-buttons .btn-default {
		display: block !important;
		width: 100%;
		margin: 5px 0;
	}

	.action-buttons .open > .dropdown-menu {
	  width: 100%;
	}

	/*.btn-primary, .btn-default {
		display: block;
		width: 100%;
		margin-bottom: 15px;
	}*/
}

@media (max-width: 1024px) {
	.dashboard-left-rail-scroll {
		height: 87% !important;
	}

	.btn-primary, .btn-default {
		display: block !important;
		width: 100% !important;
		margin-bottom: 15px !important;
	}
}
@media (max-width: 1200px) {
    .navbar-header {
        float: none;
    }
    .navbar-left,.navbar-right {
        float: none !important;
    }
    .navbar-toggle {
        display: block;
        float: left;
    }
    .navbar-collapse {
        border-top: 1px solid transparent;
		box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);		
    }
    .navbar-fixed-top {
		top: 0;
		border-width: 0 0 1px;
	}
    .navbar-collapse.collapse {
        display: none!important;
    }
    .navbar-nav {
        float: none!important;
		margin-top: 7.5px;
	}
	
	.right-nav {
		display: block;
	}
	.navbar-nav>li {
        float: none;
    }
    .navbar-nav>li>a {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    .collapse.in{
  		display:block !important;
	}
}
.navbar-brand {
	padding: 10px 15px;
}
.reveal .fa {
  font-family: 'FontAwesome';
  font-style: normal;
}

/* Hard Reset */
html, body {
	height:100%;
	margin: 0;
	padding: 0;
	position: relative;
}

html {
	font-size: 62.5%;
	-webkit-font-smoothing: antialiased;
}

body {
	background: #fff;
	font-family: "Roboto", "sans-serif";
	overflow-y: auto;
	overflow-x: hidden;
}

h1 {
	margin: 0;
	padding: 0;
	color: #333;
	font-family: "Roboto", "sans-serif";
	font-size: 2.5rem;
}

#dashboard-main-panel, #dashboard-main-panel .form-instances,
#dashboard-main-panel .dropdown .dropdown-menu li {
	font-size: 11px;
}

#dashboard-main-panel h2 {
	padding-bottom: 5px;
	border-bottom: 1px solid #d5d5d5;
	font-family: "Roboto", "sans-serif";
	font-size: 24px;
	font-size: 1.75rem;
	font-weight: 500;
	
}

#dashboard-main-panel .form-horizontal select, 
#dashboard-main-panel input[type="text"], input[type="password"], 
#dashboard-main-panel #actionGeneral select, #main-panel-rol, .main-panel-combo, 
#dashboard-main-panel loginSection select, 
.advanced-user-signup select, input[type="text"] {
	height: 25px;
	font-size: inherit;
} 

h2 small, caption {
	font-size: 18px;
	color: #333;
	font-weight: bold;
}

h3 {
	font-family: "Roboto", "sans-serif";
	font-size: 16px;
	font-size: 1.6rem;
	font-weight: 500;
}

h4 {
	font-family: "Roboto", "sans-serif";
	font-size: 16px;
	font-size: 1.6rem;
	font-weight: 500;
}

a, a:hover {
	color: var(--main-primary);
}

label {
	font-weight: normal;
}

input[type="text"], input[type="password"], input[type="numeric"], textarea {
	width: 100%;
	padding: 5px 2px 5px 8px;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;
	
	border: 1px solid #d5d5d5;
	
	box-shadow: none;
	-moz-box-shadow: none;
	-webkit-box-shadow: none;
	
	color: #333;
	font-family: "Roboto", "sans-serif";
	font-weight: 400;
}

#dashboard-main-panel textarea {
	min-height: 400px !important;
	margin-bottom: 15px;
}

#connectionSection #bindUser {
	min-height: 100px !important;
	margin-bottom: 15px;
}

#connectionSection #contextDN {
	min-height: 100px !important;
	margin-bottom: 15px;
}

#connectionSection #filter {
	min-height: 100px !important;
	margin-bottom: 15px;
}

textarea:focus {
	outline: none;
}

input[type="text"]:focus {
	color: #333333;
	outline: none;
	border-color: #bbb;
	box-shadow: none;
	-moz-box-shadow: none;
	-webkit-box-shadow: none;
}

ul.list {
	margin: 0;
	padding: 0;
}

ul.list li {
	margin: 0;
	padding: 0.3rem 0;
	list-style: none;
}

ul.list li a {
	color: var(--main-primary);
}

.badge {
	background-color: var(--main-primary);
	color: #fff;
	font-size: 1.6rem;
}


header.dashboard {
	position: fixed;
	top: 0;
	width: 100%;
	height: 50px;
	background: #fff;
	font-size: 16px;
	font-size: 1.3rem;
	z-index: 2; 
}

.topbar {
	z-index: 99997;
}
.dropdown.bootstrapMenu.designer-context-menu{
  top:20% !important;
  width: 170px !important;
}

	header.dashboard .nav li a {
		padding: 5px 10px;
		background: transparent;
		font-size: 15px;
		font-size: 1.5rem;
		font-family: "Roboto", "sans-serif";
		font-weight: 500;
		color: #333;
		text-decoration: none;
	}
	
	header.dashboard .nav li a:hover {
		background: transparent !important;
	}
	
	header.dashboard .nav .open > a, header .nav .open > a:hover, header.nav .open > a:focus, header.nav .open > a:visited {
		background: transparent !important;
		border: 0px;
	}
	
	header.dashboard .nav .dropdown .dropdown-menu a {
		font-weight: 400;
	}
	
	header.dashboard .nav .dropdown .dropdown-menu a:hover {
		background: var(--main-primary) !important;
		color: #fff;
	}
	
	header.dashboard .navbar-nav li a i {
		font-size: 16px;
		font-size: 1.6rem;
	}

	/*header .header-menu li a:hover {
		color: #799f2c;
	}

	header .header-menu i {
		font-size: 24px;
	}*/

.user-details {
	margin-top: 11px;
	margin-right: 7px;
}

.thumb-md {
	display: inline-block;
	height: 36px;
	width: 36px;
	margin-right: 10px;
}

.img-circle {
	border-radius: 50%;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
}

.user-details .dropdown {
	margin-top: 5px;
}

.user-details .dropdown-toggle {
	border: 0px;
	color: #000;
	font-weight: bold;
}

.user-details .dropdown-toggle .caret {
	margin-left: 5px;
	margin-top: 10px;
}

.user-details .dropdown-toggle:hover, .user-details .dropdown-toggle:active, .user-details .dropdown-toggle:visited {
	text-decoration: none;
}
.user-details a {
	color: #333333;
	font-size: 1.3rem;
	font-weight: bold;
	text-decoration: none;
}
.user-details a:hover {
	color: var(--main-primary) !important;
	background: transparent !important;
}
.user-details .dropdown-menu a:hover {
	background-color: #fa2b31;
	color: #fff;
}

.navbar-brand {
	height: auto;
	text-align: center;
	padding: 0;
    width: auto;
	height: 41px;
	margin-left: -5px;
	margin-top: 2px;
}

.navbar-brand label {
	float: right;
	font-size: 10px;
	margin-top: 29px;
	color: #aaa;    
	margin-right: 5px;
	margin-left: 5px;
}
	
.navbar-brand img {
	display: inline;
}


/* Navigation */
.navbar-default {
	position: fixed;
	top: 41px;
	width: 100%;
	margin: 0;
	/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#fcfcfc+38,eeeeee+100 */
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 38%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 38%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 38%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	border-bottom: 1px solid #e4e5e5;
	z-index: 1;
	min-height: 40px;
	margin-top: 5px;
}

.right-nav {
	position: absolute;
	top: 1px;
	right: 5px;
	margin: 0;
	padding: 0;
}

.navbar-default .navbar-nav>li>a, .right-nav > li > a {
	display: inline-block;
	padding: 10px 10px;
	color: #333 !important;
	font-size: 1.4rem;
	font-weight: bold;
}


.navbar-default .navbar-nav>li>a.help, .right-nav > li > a.help {
	margin-top: 3px;
	padding: 3px 7px;
	color: white !important;
	font-weight: normal;
	font: normal normal normal 11px/1 FontAwesome;
}

.right-nav li {
	display: inline-block;
	list-style: none;
	padding-right: 22px;
}

/*.right-nav li:last-child {
	padding-right: 5px;
}*/

.right-nav > li > a:hover {
	text-decoration: none;
}

.right-nav > li > a.help {
	margin-top: -1px !important;
}

.right-nav > li.refresh-report > a {
	padding-top: 12px;
}

.navbar-default .navbar-nav>li>a>i {
	margin-right: 5px;
	font-weight: normal;
}

.navbar-default .navbar-nav>li>a:hover, .navbar-default .navbar-nav>li.active>a, .navbar-default .navbar-nav>li.active>a:hover {
	color: var(--main-primary) !important;
	background: transparent !important;
}

.navbar-default .navbar-toggle, .navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:visited, .navbar-default .navbar-toggle:active {
	border-color: transparent;
	background-color: transparent !important;
}

.navbar-default .navbar-toggle .icon-bar {
	background-color: #333;
}

.navbar-default .navbar-brand {
	padding-top: 20px;
	color: #333;
}

.navbar-default .navbar-nav>.open>a, .navbar-default .navbar-nav>.open>a:focus, .navbar-default .navbar-nav>.open>a:hover {
	color: #fff;
	background-color: #c72328;
}

.navbar-default .navbar-nav>.open>a:visited, .navbar-default .navbar-nav>.open>a:active {
	color: #fff;
}

.navbar-default .dropdown-toggle {
	background: transparent;
	border: transparent;
	border-radius: 0px;
	-moz-border-radius: 0px;
	-webkit-border-radius: 0px;
}

.navbar-default .dropdown-menu {
	background-color: #c72328;
}

.navbar-default .dropdown-menu>li>a {
	color: #fff;
}

.navbar-default .dropdown-menu>li>a:hover {
	background-color: #fa2b31;
	color: #fff;
}

/*
.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {
	padding-left: 0;
	padding-right: 0;
}
*/

.form-horizontal .form-group {
	margin-left: 0;
	margin-right: 0;
}

.radio input[type="radio"], .radio-inline input[type="radio"], .checkbox input[type="checkbox"], .checkbox-inline input[type="checkbox"] {
	margin-left: -19px;
}

.form-group-flex {
	display: -ms-flexbox;      
	display: -webkit-flex;
	display: flex
}

.form-group-label {
	margin-top: 3px;
	margin-bottom: 0;
}

.form-group-text {
	margin-top: 5px;
	margin-bottom: 0;
}


.form-radio-group {
	margin-right: 2px !important;
}

.form-radio-group-left {
	margin-left: 1px !important;
}


/* Sidebar */
.dashboard-left-rail {
	float: left;
	position: fixed;
	top: 80px;
	max-width: 250px;
	width: 250px;
	height: 100%;	
	height: 100vh;
	padding: 15px 0px 130px;
	background: #f9f9f9;
	border-right: 1px solid #ddd;
	
	transition: margin-left .3s ease;
}

.dashboard-left-rail-scroll {
	width: 100%;
	height: 94%;
	margin: -10px 0 -100px;
	padding: 0px 0px 100px 0;
	overflow-y: auto;
}

@-moz-document url-prefix() {
    .dashboard-left-rail-scroll {
        height: 82vh;
        -webkit-transition: height 0.5s; 
	    -moz-transition: height 0.5s; 
	    -ms-transition: height 0.5s; 
	    -o-transition: height 0.5s; 
	    transition: height 0.5s; 
    }
}

@media screen and (max-height: 1090px) {
	@-moz-document url-prefix() {
	    .dashboard-left-rail-scroll {
	        height: 77vh;
	        -webkit-transition: height 0.5s; 
		    -moz-transition: height 0.5s; 
		    -ms-transition: height 0.5s; 
		    -o-transition: height 0.5s; 
		    transition: height 0.5s;
	    }
	}
}

@media screen and (max-height: 980px) {
	@-moz-document url-prefix() {
	    .dashboard-left-rail-scroll {
	        height: 68vh;
	        -webkit-transition: height 0.5s; 
		    -moz-transition: height 0.5s; 
		    -ms-transition: height 0.5s; 
		    -o-transition: height 0.5s; 
		    transition: height 0.5s;
	    }
	}
}

.dashboard-left-rail .btn-default {
	margin-right: 0px;
}

.action-buttons {
	margin: 0 auto 1.5rem;
	padding: 0 15px;
}

.document-group {
	margin: 5px 0 0;
}

.document.dashboard > .document-heading {
	padding: 1px 15px;
	/*border-top: 1px solid #d5d5d5;*/
	overflow: hidden;
}

.document.dashboard.active > .document-heading {
	background: var(--main-primary) !important;
	background-image: -moz-linear-gradient(var(--gradient)) !important;
	background-image: -webkit-linear-gradient(var(--gradient)) !important;
	background-image: linear-gradient(var(--gradient-ToBottom)) !important;
	border-top: 0px;
	color: #fff;
}

.document.dashboard > .document-heading > h4 {
	float: left;
	margin-top: 9px;
	margin-left: 0px;
	font-family: "Roboto", "sans-serif";
	font-weight: 500;
	font-size: 18px;
	font-size: 1.4rem;
	letter-spacing: 0.2px;
}

.document.dashboard > .document-heading > h4 > a {
	color: #333;
}

.document.dashboard > .document-heading > h4 > a:visited, .document.dashboard > .document-heading > h4 > a:active {
	text-decoration: none !important;
}

.document.dashboard > .document-heading > h4 > a:hover {
	text-decoration: none;
}


.document.dashboard.active > .document-heading > h4 > a {
	color: #fff;
}

.document.dashboard > .document-heading .switch {
	float: right;
	margin: 7px 0;
}

.document.dashboard > .document-heading > .switch > .pf {
	color: #333;
	font-size: 14px;
	font-weight: normal;
}

.document.dashboard.active > .document-heading > .switch > .pf {
	color: #fff;
	font-size: 14px;
	font-weight: normal;
}

.document.dashboard > .document-heading > .switch:hover, .document.dashboard.active > .document-heading > .switch:hover {
	text-decoration: none;
}

.document.dashboard.active > .document-body {
	background: #fff;
	box-shadow: inset 0px 0px 10px #bbb;
	-moz-box-shadow: inset 0px 0px 10px #bbb;
	-webkit-box-shadow: inset 0px 0px 10px #bbb;
}

.document.dashboard > .document-heading > .draggable {
	float: left;
	margin-top: 10px;
	margin-left: 25px;
}

.document.dashboard > .switch {
	float: right;
	display: block;
	margin-top: 5px;
	font-size: 14px;
	/*font-size: 2.0rem;*/
	font-weight: bold;
}

.document-items.dashboard {
	padding: 0px 10px 10px 10px;
}

.document-items.dashboard:first-child {
	padding-top: 10px;
}

.document-items.dashboard > .bo-heading {
	overflow: hidden;
	padding: 3px;
}

.document-items.dashboard > .bo-heading h5 {
	float: left;
	width: 90%;
	margin: 0;
	padding: 2px 0;
	
	font-size: 16px;
	font-size: 1.4rem;
	font-family: "Roboto", "sans-serif";
	font-weight: 500;
}

.document-items.dashboard > .bo-heading h5 > i {
	margin-right: 5px;
}

.document-items.dashboard > .bo-heading .badge {
	background:  var(--main-primary);
	
	color: #fff;
	font-family: "Roboto", "sans-serif";
	font-size: 12px;
	font-size: 1.2rem;
	font-weight: 500;
}

.document-items.dashboard > .bo-heading .switch {
	float: right;
}

.document-items.dashboard > .bo-heading .switch .pf {
	color: #333;
	font-size: 14px;
	/*font-size: 1.8rem;*/
	font-weight: normal;
}

.document-items.dashboard > .bo-heading .switch:hover {
	text-decoration: none !important;
}

.document-item.dashboards > .bo-body ul, .document-body ul {
	padding-left: 20px;
}

.document-items.dashboard > .bo-body ul li, .document-body ul li {
	padding: 5px 0;
	font-family: "Roboto", "sans-serif";
	font-weight: 400;
	list-style: none;
	font-size: 1.2rem;

	position: relative;
    width: 100%;
    clear: both;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.document-items.dashboard > .bo-body ul li a, .document-body ul li a {
	color: #333;
	padding-left: 5px;
	/*
	height: 15px;
	display: inline-block;
	width: 84%;*/
}

.document-items.dashboard > .bo-body ul li a.bg-active, .document-body ul li a .bg-active {
	color: white;
}

.document-items > .bo-body ul li.controlSelected > a {
	color: var(--main-primary) !important;
	font-weight: bold;
}

/* .content-wrap */
.content-wrap {
	width: calc(100vw - 250px);
	min-height: calc(100vh - 65px);
	margin-left: 250px;
	padding: 15px 0;
	padding-top: calc(70px + 2rem);
	transition: width .3s ease, margin-left .3s ease;
	/*overflow-y: scroll;*/
	/*overflow-x: hidden;*/
}

/* When AI panel is open, shrink main content */
.ai-panel-open .content-wrap {
	width: calc(100vw - 250px - 380px);
}

/* AI ChatBot Right Panel */
.dashboard-right-rail {
	position: fixed;
	right: 0;
	top: 80px;
	width: 380px;
	height: calc(100vh - 80px);
	background: #fff;
	border-left: 1px solid #d5d5d5;
	z-index: 100;
	display: flex;
	flex-direction: column;
	box-shadow: -2px 0 8px rgba(0,0,0,0.08);
}

.right-panel-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 12px;
	background: var(--accent-color, #F89B3C);
	color: #fff;
	font-size: 13px;
	font-weight: 600;
	flex-shrink: 0;
}

.right-panel-close {
	background: none;
	border: none;
	color: #fff;
	font-size: 18px;
	cursor: pointer;
	padding: 0 4px;
	line-height: 1;
	opacity: 0.8;
}

.right-panel-close:hover {
	opacity: 1;
}

#AIChatPanelContent {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

/* Panel mode overrides for the chat modal */
/* Panel resize handle */
.panel-resize-handle {
	position: absolute;
	left: 0;
	top: 0;
	width: 4px;
	height: 100%;
	cursor: col-resize;
	z-index: 101;
	background: transparent;
	transition: background 0.15s;
}

.panel-resize-handle:hover,
.panel-resizing .panel-resize-handle {
	background: var(--accent-color, #F89B3C);
}

/* Prevent text selection while resizing */
.panel-resizing {
	user-select: none;
	cursor: col-resize !important;
}

#AIChatPanelContent #ai-chat-modal {
	display: flex !important;
	flex-direction: column;
	height: 100%;
	border: none;
	padding: 0;
}

#AIChatPanelContent .ai-chat {
	flex: 1;
	overflow-y: auto;
	padding: 10px;
}

#AIChatPanelContent .input-group.search-area {
	flex-shrink: 0;
	padding: 8px 10px;
	border-top: 1px solid #e0e0e0;
	background: #fafafa;
}

#AIChatPanelContent #messageCounter {
	flex-shrink: 0;
	padding: 6px 10px;
	font-size: 10px;
	text-align: center;
	border-top: 1px solid #f0f0f0;
	background: #fafafa;
}

/*
.row .col {
	padding-bottom: 2rem;
	padding-right: 5rem;
	padding-left: 3rem;
}
*/

.block {
	margin-bottom: 30px;
}

.content-wrap .row {
	padding: 5px 30px 4px 30px;
}

.connection .row{
	padding: 5px 0 4px 15px;
}

.connection .middle-align{
	margin-top: 3px;
}

#dashboard-main-panel .breadcrumb {
	margin-bottom: 0px;
	padding: 10px 31px;
	border-top: 1px solid #d5d5d5;
	border-bottom: 1px solid #d5d5d5;
}

#dashboard-main-panel .page-title h1 {
	font-size: 1.9em;
	margin-bottom:7px;
}

ul.directory-tree {
  margin: 20px 0px 0px 0px;
  padding: 0 0 0 25px;
  list-style: none;
  line-height: 2em;
  font-family: Arial;
}
ul.directory-tree li {
  font-size: 1.1rem;
  position: relative;
  list-style: none;
}

span.detFormInstance:hover{
	cursor: pointer;
	color: #ffffff !important;
	background: var(--main-primary) !important;
	background-image: -moz-linear-gradient(var(--gradient)) !important;
	background-image: -webkit-linear-gradient(var(--gradient)) !important;
	background-image: linear-gradient(var(--gradient-ToBottom)) !important;
}


ul.directory-tree li:before {
  position: absolute;
  left: -15px;
  top: 0px;
  content: '';
  display: block;
  border-left: 1px solid #d5d5d5;
  height: 1em;
  border-bottom: 1px solid #d5d5d5;
  width: 10px;
}
ul.directory-tree li:after {
  position: absolute;
  left: -15px;
  bottom: -7px;
  content: '';
  display: block;
  border-left: 1px solid #d5d5d5;
  height: 100%;
}
ul.directory-tree li.root {
  margin: 0px 0px 0px -20px;
}
ul.directory-tree li.root:before {
  display: none;
}
ul.directory-tree li.root:after {
  display: none;
}
ul.directory-tree li:last-child:after {
  display: none;
}

/* dropdowns */

/* Styled select box */
.dropdown {
	position: relative;
	margin-top: 0px;
}

.dropdown-toggle {
	width: 100%;
	text-overflow: ellipsis;
}

.dropdown button {
  background: white;
  width: 100%;
  padding: 5px 0px 5px 8px;
  border: 1px solid #bbb;
  font-family: "Roboto", "sans-serif";
  font-weight: 400;
  font-size: 14px;
  font-size: 1.4rem;
  color: #333;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  text-align: left;
}

.dropdown button:hover, .dropdown button:active, .dropdown button:focus, .dropdown button:visited {
	background: #fff;
}

.open > .dropdown-toggle.btn-default:hover, .open > .dropdown-toggle.btn-default:focus, .btn-default:active.focus, .btn-default.active.focus, .open > .dropdown-toggle.btn-default.focus {
	background: #fff;
	border-color: #d5d5d5
}

.dropdown .caret {
	float: right;
	margin: 5px 12px 0 0;
}

@-moz-document url-prefix() {
	.dropdown .caret {
		margin: -12px 12px 0 0;
	}
}

.dropdown .dropdown-menu {
	width: 100%;
	min-width: 140px;
}

.dropdown .dropdown-menu li {
	font-size: 14px;
	font-size: 1.4rem;
}

.dropdown .dropdown-menu a:hover {
	background: #86b823;
	color: #fff;
}

.dropdown-menu {
	cursor: pointer;
}

.dropdown-menu > li > a {
	padding: 3px 18px !important;
	font-size: 11px;

}

.dropdown-menu::before {
  position: absolute;
  top: -7px;
  right: 9px;
  display: inline-block;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #d5d5d5;
  border-left: 7px solid transparent;
  border-top: 0px;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.dropdown-menu::after {
  position: absolute;
  top: -6px;
  right: 10px;
  display: inline-block;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  border-left: 6px solid transparent;
  border-top: 0px;
  content: '';
}

dl {
	width: 100%;
	padding: 0;
    margin: 0;
    overflow: hidden;

}

dt {
	float: left;
  	width: 50%;
  	padding: 0;
  	margin: 0 0 5px;
  	font-weight: normal;
}

dd {
	float: left;
  	width: 50%;
  	padding: 0;
  	margin: 0 0 5px;
  	text-align: right;

}

.panel {
	height: 180px;
	overflow-y: auto;
	margin-bottom: 5px;
}

/* Submenu for drop down */
/*.dropdown-submenu {
    position:relative;
}
.dropdown-submenu>.dropdown-menu {
    top:0;
    left:100%;
    margin-top:-6px;
    margin-left:-1px;
    -webkit-border-radius:0 0px 0px 0px;
    -moz-border-radius:0 0px 0px 0px;
    border-radius:0 0px 0px 0px;
}
.dropdown-submenu:hover>.dropdown-menu {
    display:block;
}
.dropdown-submenu>a:after {
    display:block;
    content:" ";
    float:right;
    width:0;
    height:0;
    border-color:transparent;
    border-style:solid;
    border-width:5px 0 5px 5px;
    border-left-color:#fff;
    margin-top:5px;
    margin-right:-10px;
}
.dropdown-submenu:hover>a:after {
    border-left-color:#ffffff;
}
.dropdown-submenu.pull-left {
    float:none;
}
.dropdown-submenu.pull-left>.dropdown-menu {
    left:-100%;
    margin-left:10px;
   -webkit-border-radius:0 0px 0px 0px;
    -moz-border-radius:0 0px 0px 0px;
    border-radius:0 0px 0px 0px;
}*/

.dropdown-submenu>a:after {
	margin-top: 4px;
}

.row-centered {
	text-align: center;
}

.col-centered {
	float: none;
	margin: 0 auto;
}

/* Global elements */

/***
.help {
	padding: 1px 2px;
	
	background: #fcfcfc;
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%);
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%);
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 );
	

	
	border: 1px solid #d5d5d5;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;
	
	color: #799f2c;
}
*/

.help:hover {
	color:  var(--main-primary);
}

.style-btn {
	padding: 1px 6px;
	
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	
	/*box-shadow: 0px 1px 5px #d5d5d5;
	-moz-box-shadow: 0px 1px 5px #d5d5d5;
	-webkit-box-shadow: 0px 1px 5px #d5d5d5;*/
	
	border: 1px solid #d5d5d5;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;
	
	color: #333;
}

/* Buttons */
.btn-group {
	width: 100%;
}
#dashboard-main-panel .btn, #dashboard-left-panel .btn {	
	padding: 6px 30px;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;
	font-family: "Roboto", "sans-serif";
	font-size: 1.3rem;
}

#dashboard-main-panel .btn-default, #dashboard-left-panel .btn-default {
	/*margin-right: 15px;*/
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	
	border: 1px solid #d5d5d5;
	
	box-shadow: 0px 2px 5px #d5d5d5;
	-moz-box-shadow: 0px 2px 5px #d5d5d5;
	-webkit-box-shadow: 0px 2px 5px #d5d5d5;
	
	color: #333;
	font-weight: 700;
}

#dashboard-main-panel .btn-default:hover, #dashboard-left-panel .btn-default:hover {
	border-color: #d5d5d5;
}

@media screen and (max-width: 768px) {
	#dashboard-main-panel .panel-body .info-settings {
		width: 100%;
	}
}

.btn-primary {
	background: var(--main-primary);
	background-image: -moz-linear-gradient(var(--gradient));
	background-image: -webkit-linear-gradient(var(--gradient));
	background-image: linear-gradient(var(--gradient-ToBottom));
	
	border: 1px solid var(--main-primary);
	
	/*box-shadow: 0px 2px 5px #d5d5d5;
	-moz-box-shadow: 0px 2px 5px #d5d5d5;
	-webkit-box-shadow: 0px 2px 5px #d5d5d5;*/
	
	color: #fff;
	font-weight: 700;
}

.btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {
	color: #fff;
	background: var(--main-primary);
	background-image: -moz-linear-gradient(var(--gradient));
	background-image: -webkit-linear-gradient(var(--gradient));
	background-image: linear-gradient(var(--gradient-ToBottom));
	border: 1px solid var(--main-primary);
}

.action-buttons .dropdown-menu::before {
  position: absolute;
  top: -7px;
  right: 81px;
  display: inline-block;
  border-right: 7px solid transparent;
  border-bottom: 7px solid #d5d5d5;
  border-left: 7px solid transparent;
  border-top: 0px;
  border-bottom-color: rgba(0, 0, 0, 0.2);
  content: '';
}

.action-buttons .dropdown-menu::after {
  position: absolute;
  top: -6px;
  right: 82px !important;
  display: inline-block;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #ffffff;
  border-left: 6px solid transparent;
  border-top: 0px;
  content: '';
}

.action-buttons .btn-primary {
	margin-right: 0px;
}

/* Search box */
.search-box input[type="text"] {
	width: 99%;
	padding: 5px 5px 5px 8px;
	border-radius: 4px;
	-moz-border-radius: 4px;
	-webkit-border-radius: 4px;
	
	border: 1px solid #d5d5d5;
	
	box-shadow: none;
	-moz-box-shadow: none;
	-webkit-box-shadow: none;
	
	color: #949494;
	font-family: "Roboto", "sans-serif";
	font-weight: 400;
	font-size: 1.2rem;
	height: 25px;
	font-size: 11px;
}

.search-box input[type="text"]:focus {
	color: #333333;
	outline: none;
	border-color: #bbb;
	box-shadow: none;
	-moz-box-shadow: none;
	-webkit-box-shadow: none;
}

/* Styled select box */


.dropdown-toggle {
	width: 100%;
	text-overflow: ellipsis;
}

.dashTbl-icon{
	width:  20px !important;
	height:  20px !important;
	font-size:  12px !important;
	background: #ababab;
	padding:  2px 2px !important;
	color: #ffffff;
	border-right-color:  #a8a8a8;
	border-bottom-color:  #a8a8a8;
	margin-top: 2px;
}

.dashTbl-icon:disabled{
	cursor: default;
}

/* Draggable */
.draggable:hover {
	cursor: move;
}

.progress-bar-success {
	background: #8eb934; /* Old browsers */
	background: -moz-linear-gradient(top, #8eb934 0%, #799f2d 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top, #8eb934 0%,#799f2d 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom, #8eb934 0%,#799f2d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8eb934', endColorstr='#799f2d',GradientType=0 );
}

.progress-bar-warning {
	background: #f29a31; /* Old browsers */
	background: -moz-linear-gradient(top, #f29a31 0%, #c77e28 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top, #f29a31 0%,#c77e28 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom, #f29a31 0%,#c77e28 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f29a31', endColorstr='#c77e28',GradientType=0 );
}

.progress-bar-danger {
	background: #e82e2d; /* Old browsers */
	background: -moz-linear-gradient(top, #e82e2d 0%, #c42726 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top, #e82e2d 0%,#c42726 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom, #e82e2d 0%,#c42726 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e82e2d', endColorstr='#c42726',GradientType=0 );
}

/*.nav-tabs > li:first-child.active > a {
	border-right: 1px solid #d5d5d5;
}*/

.nopadding {
   padding: 0 !important;
   margin: 0 !important;
}

.nopadding-l {
	padding-left: 0px !important;
}

.nopadding-r {
	padding-right: 0px !important;
	margin-right: 0px !important;
}


.strong {
	font-weight: bold !important;
}

/*.icon-gradient:before {
	background: -webkit-gradient(linear, left top, left bottom, from(#9e9e9e), to(#777));
	    -webkit-background-clip: text;
	    -webkit-text-fill-color: transparent;
		text-shadow: 0px 1px 2px rgba(0,0,0,0.2);
}*/

/* Attention level tooltips */
.attn-tooltip {outline:none; }
.attn-tooltip strong {line-height:10px;}
.attn-tooltip:hover {text-decoration:none;} 
.attn-tooltip .attn-tooltip-container {
    z-index:10;
    display:none; 
    padding:5px 15px;
    margin-top:-30px; 
    margin-left:0px;
    /*width:300px; */
    line-height:16px;
    -webkit-animation: fadeout 0.5s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadeout 0.5s; /* Firefox < 16 */
        -ms-animation: fadeout 0.5s; /* Internet Explorer */
         -o-animation: fadeout 0.5s; /* Opera < 12.1 */
            animation: fadeout 0.5s;
}
@keyframes fadeout {
    from { opacity: 1; }
    to   { opacity: 0; }
}

/* Firefox < 16 */
@-moz-keyframes fadeout {
    from { opacity: 1; }
    to   { opacity: 0; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadeout {
    from { opacity: 1; }
    to   { opacity: 0; }
}

/* Internet Explorer */
@-ms-keyframes fadeout {
    from { opacity: 1; }
    to   { opacity: 0; }
}

/* Opera < 12.1 */
@-o-keyframes fadeout {
    from { opacity: 1; }
    to   { opacity: 0; }
}

.attn-tooltip:hover .attn-tooltip-container{
    display:inline; 
    position:absolute; 
    color:#333;
    border:1px solid rgba(213,213,213, 0.8); 
    background: rgba(255,255,255, 0.8);
    text-align: left;

    -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */
       -moz-animation: fadein 0.5s; /* Firefox < 16 */
        -ms-animation: fadein 0.5s; /* Internet Explorer */
         -o-animation: fadein 0.5s; /* Opera < 12.1 */
            animation: fadein 0.5s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}


    
/*CSS3 extras*/
.attn-tooltip .attn-tooltip-container
{
    border-radius:4px;
    /*box-shadow: 5px 5px 8px #CCC;*/
}


/* Alerts */

.alert-container {
	position: absolute;
	width: 98%;
	top: 10px;
	left: 0px;
	z-index: 100;
}

.alert {
	display: table;
	
	margin: 15px auto;
	padding: 0;
	top: 10px;
	min-width: 20%;
	max-width: 30%;
	
	background: #fcfcfc; /* Old browsers */
	background: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */
	background: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */
	background: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */
	
	border: #d5d5d5;
	
}

.alert-icon {
	display: table-cell;
	width: 57px;
	height: 100%;
	margin-right: 20px;
	padding: 10px;
	font-size: 3.0rem;
	font-size: 30px;
	text-align: center;
	vertical-align: middle;
}

.alert-content {
	display: table-cell;
	padding: 10px;
	font-size: 1.4rem;
	font-size: 14px;
	vertical-align: middle;
	min-width:600px;
}

.alert-close {
	display: table-cell;
	vertical-align: top;
}

.alert-dismissable .close, .alert-dismissible .close {
	top: 2px;
	right: 10px;
}


.alert-warning {
	width: 30%;
	border: 1px solid #938f23 !important;
	box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);
	color: #333;
}

.alert-warning .alert-icon {
	background: rgba(147,143,35, 0.10);
	color: #807d2c;
}

.alert-danger {
	width: 30%;
	border: 1px solid #a73837 !important;
	box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);
	color: #333;
}

.alert-danger .alert-icon {
	background: rgba(231,67,67,0.10);
	color: #7d2a2a;
}

.alert-success {
	width: 30%;
	border: 1px solid #5e8c26 !important;
	box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);
	color: #333;
}

.alert-success .alert-icon {
	background: rgba(94,140,38,0.10);
	color: #497c30;
}

.alert-info {
	width: 30%;
	border: 1px solid #2d84a4;
	box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);
	color: #333;
}

.alert-info .alert-icon {
	background: rgba(45,132,164, 0.10);
	color: #246a84;
}

.alert-view {
	border: 1px solid #cc7929;
	box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);
	-moz-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);
	-webkit-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);
	color: #333;
}

.alert-view .alert-icon {
	background: rgba(204,121,41, 0.10);
	color: #b76d25;
}

/*Modal*/
.modal-header {
	text-align: left;
	border: 0px;
}

.modal-header h4 {
	padding-bottom: 8px;
	font-size: 2.4rem;
	font-size: 24px;
	border-bottom: 1px solid #e5e5e5;
}

.modal-body {
	text-align: left;
}

.modal-footer {
	border: 0px;
}

.modal-footer .btn {
	width: auto;
}

/* Styles for row click selection on jqgrid */
.ui-jqgrid-btable .ui-state-highlight { background: #dff0d8 !important; }
.ui-jqgrid .ui-state-highlight { background: #dff0d8 !important; }


/*PF-5427 style to show properly the asc/desc sort icon in jqgrids */
.ui-jqgrid .s-ico > .ui-icon-asc.ui-icon.ui-sort-ltr, .ui-jqgrid .s-ico > .ui-icon-desc.ui-icon.ui-sort-ltr {
     margin-left: 0;
}

.ui-jqgrid .s-ico > .ui-icon-asc.ui-icon {
    top: -3px;
}

.ui-jqgrid .s-ico > .ui-icon-desc.ui-icon {
    top: -10px;
}

#dashboard-main-panel .pf-btn-small{
	padding:5px 5px 5px 5px
}

body{
	overflow: scroll;
}

#file-upload-button{
	padding: 0;
}

#file-upload-label{
	height: 24px;
	width: 90px;
	padding: 5px 0;
	margin: 0;
	font-weight: bold;
	font-size: 12px;
}

.file-upload-label{
	height: 24px;
	width: 90px;
	padding: 5px 0;
	margin: 0;
	font-weight: bold;
	font-size: 12px;
}

#dashboard-main-panel textarea[name="IPList"]{
	min-height: 0 !important;
}

#dashboard-main-panel #recentEdits ul li,
#dashboard-main-panel #recentEditsEFD ul li,
#dashboard-main-panel #favoriteForms  ul li {
	font-size: 1.2rem;
	padding: 0.3rem 0;
}

#dashboard-main-panel #actionDetails h4, #dashboard-main-panel #actionDetails .block {
	margin-bottom: 0 !important;
}

#dashboard-main-panel #actionDetails h2, #dashboard-main-panel #actionGeneral h2 {
	margin-top: 0 !important;
}

#dashboard-main-panel #actionDetails .row, 
#dashboard-main-panel #actionGeneral .row,
#dashboard-main-panel #connectionGeneral .row {
	padding-bottom: 0 !important;
}

#dashboard-main-panel #actionDetails .ui-jqgrid-bdiv {
	max-height: 165px !important;
}

.statusWarning{
	color:red;
}

.select-list {
	padding: 5px;
}

.select-list li {
	padding: 0.15em 0 0.5em 1.9em;
	margin-bottom: 0.2em;
	text-indent: 0.4em;
	/*font-weight:bold;*/
	list-style: none;
	background-repeat: no-repeat;
	min-height:25px;
}
.select-list li[data-type="group"]{
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.select-list li[data-type="user"]{
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.select-list li[data-type="position"]{
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.select-list li[data-type="everyone"]{
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.select-list li[data-type="world"]{
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.col-sm-1 {
    height: 30px;    
}

.bottom-align{
	position: absolute; left: 0; bottom: 0
}

.li-disabled{
	pointer-events:none;
    opacity:0.6;
}

.row-hidden{
	opacity: .3 !important;
}

.attention-level-left-padding{
	padding-left: 40px;
}

.perm-detail-panel {
	border: 1px solid #d8d8d8;
	margin-left: 1em;
	margin-right: 5em;
}

.perm-name {
	margin-left: -1em;
}

.dim-text {
	color: #aaaaaa;
}
#pf-upgrade-urgent > a {
	color:red !important;
}

#pf-upgrade-normal > a {
	color:gray !important;
}

.ui-autocomplete-loading {
    background: white url(${___CSS_LOADER_URL_REPLACEMENT_4___}) right center no-repeat;
  }

.ui-autocomplete {
    max-height: 500px;
    overflow-y: auto;
    /* prevent horizontal scrollbar */
	overflow-x: hidden;
	font-size: 11px;
}
  /* IE 6 doesn't support max-height
   * we use height instead, but this forces the menu to always be this tall
   */
* html .ui-autocomplete {
    height: 500px;
}
.disable-link{
	pointer-events: none
}

.dashboard-favorited-item {
	background: linear-gradient(var(--gradient-ToBottom));
}

/*dialogs*/
.ui-dialog {
	font-size: 12px;
	font-family: 'Poppins';
}

#dialog, #dialog-greeting, #report-form-dialog, #deleteModal, #confirmDeleteModal {
	font-size: 12px;
}

#dialog h4 {
	font-size: 1.4rem;
}

.ui-dialog-buttonset button{
	font-family: 'Poppins';
}

.confirm-delete-top-section {
	padding: 0 0 0 15px; width: 100%; height: auto !important;
}

.confirm-delete-bottom-section {
	padding: 0 0 10px 15px; width: 100%; height: auto !important;
}

.map-versions-bottom-section {
	padding: 0 0 10px 15px; width: 100%;
}

.map-versions-bottom-section .ui-jqgrid-view{
	padding: 1px !important;
}

.form-link-modal {
	padding: 0 0 0 15px; width: 100%;
}

/*Dashboard permissions*/
@media screen and (max-width: 1200px) {
	.permissions-list {
		height: 100px; 
		margin-bottom: 10px;
	}
}
/***********************/

/*For button choose in color picker*/
.sp-container button {
	font-size: 11px !important;
}


/*Scroll bar change to auto for some components*/
.show-scroll-bar-y {
	overflow-y: auto;
}

.pre-scrollable {
	overflow-y: auto;
}

form.migrate-form hr {
	margin: 0;
}
form.migrate-form span.header {
	font-weight: bold;
}
form.migrate-form span.separator {
	margin-right: 10px;
}
form.migrate-form input[type="radio"] {
	margin-top: 1px;
	vertical-align: middle;
}

form.migrate-form input[type="checkbox"] {
	margin-top: -1.5px;
    vertical-align: middle;
}
/*Refresh connections*/

.refresh-actions {
	padding-top: 2px;
	padding-left: 8px;
	text-align: end;
}

.dashboard-left-rail-scroll ul li a {
    display: inline;
}


/*Settings button*/
.toolbar-button-container {
	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-o-user-select: none;
	user-select: none;
	width: 55px !important; 
	height: 55px !important;  	
}

.toolbar-button-container div {  
	width: 55px !important; 
	height: 55px !important;  
}

.toolbar-button {
	display: inline-block;
    color: #444;
    border: 1px solid #CCC !important;
    border-radius: 5px;
    background: linear-gradient(to bottom, #fcfcfc 0%,#eeeeee 100%); 
    cursor: pointer;
    vertical-align: middle;
    text-align: center;
    height: 50px !important;
	width: 53px !important;
	margin: 0 auto 2px 9px !important;
}

.toolbar-button i {
	margin-top: 4px !important;
	color:  var(--main-primary) !important;
}

.toolbar-button p {
	margin-top: -6px !important;
	color:  var(--main-primary) !important;
}
	
.toolbar-button p.assets-top {
	margin-top: 12px !important;	 
}


/*Messages shown when mobile*/
#dashboard-main-panel .message-container-mobile {
	display: inline-flex;
}

#dashboard-main-panel .message-container-mobile > label {
	font-weight: bold; line-height: normal; text-align: justify; font-size: 13px;
}

.format-table-properties .ui-jqgrid-bdiv {
	max-height: 135px !important;
	overflow-x: hidden;
	overflow-y: auto !important;
}

.format-table-sources .ui-jqgrid-bdiv {
	overflow-x: hidden;
	overflow-y: auto !important;
}

.format-table-overflow-shown { 
	overflow-x: auto !important; 
}

/*PF-3986*/

.btn-disabled {
	opacity: 0.5;
  	background: #CCC;
}

.right-menu {
	position:relative;
	float:right;
}
.right-caret {

	border-bottom: 4px solid transparent;
	border-top: 4px solid transparent;
	border-left: 4px solid #000000;
	display: inline-block;
	height: 0;
	opacity: 1;
	vertical-align: top;
	width: 0;

}
.right
{
	float:right;
}

.dropdown-submenu {
	position:relative;
}
.dropdown-submenu>.dropdown-menu {
	top:0;
	left:100%;
	margin-top:-6px;
	margin-left:-1px;
	-webkit-border-radius:0 6px 6px 6px;
	-moz-border-radius:0 6px 6px 6px;
	border-radius:0 6px 6px 6px;
}
.dropdown-submenu:hover>.dropdown-menu {
	display:block;
}
.dropdown-submenu>a:after {
	display:block;
	content:" ";
	float:right;
	width:0;
	height:0;
	border-color:transparent;
	border-style:solid;
	border-width:5px 0 5px 5px;
	border-left-color:#cccccc;
	margin-top:5px;
	margin-right:-10px;
}
.dropdown-submenu:hover>a:after {
	border-left-color:#ffffff;
}
.dropdown-submenu.pull-left {
	float:none;
}
.dropdown-submenu.pull-left>.dropdown-menu {
	left:-100%;
	margin-left:10px;
	-webkit-border-radius:6px 0 6px 6px;
	-moz-border-radius:6px 0 6px 6px;
	border-radius:6px 0 6px 6px;
}

.jqGrid-alt-row{
	background-color: #DDDDDC;
}

.item-link{
	cursor: pointer;
}

#accountDetails input[type=checkbox], #accountDetails input[type=radio] {
	vertical-align: middle;
	position: relative;
	bottom: 1px;
	margin: 0 5px 0 0;
}
  
#accountDetails input[type=radio] {
	bottom: 2px;
}


.col-form-label{
	padding-top: 4px;
}

.instances-filter{
	margin-bottom: 0;
}

.ui-dialog-buttonpane{
	border: none;
}

.button-as-dropdown{
	padding: 5px 8px!important;
}

.button-as-dropdown .caret{
	margin: 8px 0 0 0!important;
}

.helpSection{
	margin-bottom: 10px;
}

.inputWithButton{
	width: 80%!important;
	float:left!important;
}

@media (min-width: 1400px) {
	.inputWithButton{
		width: 88%!important;
	}
}

.buttonWithInput{
	float: right!important;
}

.actionButtons{
	margin-top:10px;
}

input[type=checkbox], input[type=radio]{
	vertical-align: -2px;
}

.quick-help-view{
	margin-right: -15px;
	position: absolute;
    z-index: 9999999;
}

.quick-help .header{
	height: 30px;
	margin-top: 5px;
}

.quick-help .tag{
	width: 30px;
    background-color: var(--accent-color);
    height: 30px;
	color: #ffffff;
	cursor: pointer;
	padding-left: 12px;
    font-size: 23px;  
}

.quick-help .opened-tag{
	width: 0;
}

.quick-help .opened-tag .text{
	font-size: 15px;
    background-color: #fff;
    height: 30px;
    border-top: solid 1px #c5c5c5;
    margin-left: 30px;
    font-weight: bold;
	padding: 5px;
	font-family: Poppins;
}

.quick-help .opened-tag .tag{
	padding-left: 4px;
	float: left;
}

.quick-help .opened-tag img{
	width: 22px;
    margin-top: -4px;
}

.quick-help .closed-tag .tag{
	border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.quick-help .opened-help{
	float:left;
	overflow: hidden;
	background: #fff;
    box-shadow: 4px 6px 4px 0px rgba(0, 0, 0, 0.25);
	width: 0px;	
}

.quick-help .box-inner{
	padding: 10px;    
	border: 1px solid #c5c5c5;
	display: none;
	font-size: 14px;
	font-family: Poppins;
}

.quick-help ul{
	list-style: none;
	padding: 0;
}

.quick-help li{
	padding: 2.5px 5px;
}

.quick-help li:hover{
	background-color: #F1F1F1;	
	cursor: pointer;
}

.quick-help hr{
	margin: 10px 0;
}

.dashboard-modal-dialog{
	border-radius: 10px;
    box-shadow: 1px 1px #C5C5C5;
	font-family: Poppins;
}

.dashboard-modal-dialog svg{
	fill: var(--main-primary);
}

.dashboard-modal-dialog a{
	font-family: Poppins!important;
    font-weight: 600!important;
}

.dashboard-modal-dialog-titlebar{
	border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 40px;
    background: none!important;
    background-color: var(--accent-green)!important;
    margin: 1px;
	text-align: center;
    padding: 8px!important;
}

.dashboard-modal-dialog-titlebar-hidden{
	display: none;
}

.dashboard-modal-title{
	float: none!important;
	margin: 0!important;
	font-size: 18px;
}

.dashboard-modal-dialog-titlebar-notification{
	border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 35px;
    background: none!important;
    background-color: var(--accent-green)!important;
    margin: 1px;
	text-align: left;
    padding: 8px!important;
}

.dashboard-modal-title-notification{
	float: none!important;
	margin: 0!important;
	font-size: 14px;
}

.dashboard-modal-content{
	margin: 20px 0;
}

.dashboard-modal-button{
	background-color: var(--accent-color);
    color: #fff;
    border: #fff;
    height: 25px;
    width: 90px;
    box-shadow: 2px 2px #C5C5C5;
    border-radius: 5px;
}

.divider{
	height: 2px;
	width: 100%;
	background-color: #F5F5F5;
}

.workspace{
	font-family: Poppins;
}

.dashboard-card{
	width: 20vw;
	margin-bottom: 5px;
	cursor: pointer;
}

.ui-dialog .dashboard-card{
	width: 15vw;
}

.workspace .title{	
    font-size: 2vw;
    margin: 20px 0;
}

.workspace .text{
	font-size: 1.2vw;
}

.trial-status{
	border: #C5C5C5 1px solid;
    margin: 10px 10px;
	padding: 0 15px;
	font-family: Poppins;
	border-radius: 10px;
	box-shadow: 3px 3px 5px #C5c5c5;
	font-size: 12px;
}

.trial-status .title{
	background-color:var(--accent-color);
    color: #fff;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    padding: 10px 15px;
    font-size: 15px;
    font-weight: 500;
	letter-spacing: .2px;
}

.trial-status .content{
	margin: 15px;
}

.trial-status .button{
	margin-top: 15px;
}

.trial-status button, 
.workspace button{
	background-color: var(--accent-color);
    color: #fff;
    border: none;
    padding: 10px 12px;
    border-radius: 5px;
    font-weight: 500;
    font-size: 13px;
    box-shadow: 3px 3px 5px #C5c5c5;
	letter-spacing: .2px;
}

.dashboard-accent-button{
	font-weight: 600;
	min-width: 100px;
}

.modal-container{
	font-family: Poppins;
}

.modal-button{
	color: #fff;
    border: none;
    padding: 10px 12px;
    border-radius: 5px;
    font-weight: 500;
    font-size: 13px;
    box-shadow: 3px 3px 5px #C5c5c5;
	letter-spacing: .2px;
	font-weight: 600;
	min-width: 100px;
	cursor: pointer;

	transition: background 0.3s ease-in-out;
}

.modal-accent-button{
	background: linear-gradient(to bottom, var(--accent-color) 0%, var(--gradient-accent-color) 100%);
}

.modal-accent-button:hover {
    background: linear-gradient(to bottom, var(--gradient-accent-color) 0%, var(--accent-color) 100%);
}

.modal-cancel-button{
	background: linear-gradient(to bottom, #fcfcfc 0%, #eeeeee 100%);
	border: 1px solid #d5d5d5;
	color: #000000;
}

.modal-cancel-button:hover {
    background: linear-gradient(to bottom, #eeeeee 0%, #fcfcfc 100%);
	font-weight: bold;
}

.workspace .row{
	padding: 5px 22px;
}

.trial-status .indicators{
    margin-top: 5px;
    margin-bottom: 15px;
}

.trial-status .indicator{
	height: 8px;
    border-radius: 10px;
	float: left;
    margin-right: 5px;
}

.trial-status .used{
	background:var(--main-primary);
}

.trial-status .notUsed{
	background: #D9D9D9;
}

.trial-status .remaining-border{
	border-radius: 15px;
    background-color: var(--main-primary);
    width: 177px;
    height: 8px;
    padding: 2px 3px;
}

.trial-status .remaining-fill{
	border-radius: 10px;
    height: 4px;
    background-color: #fff;
}

.workspace-table{
	font-size: 13px;
}

.workspace-table .row{
	padding: 0 15px;
}

.workspace-table .app-name{
	font-weight: 600;
    font-size: 13px;
}

.workspace-table .app-lastUpdate{
	font-size: 11px;
}

.workspace-table a{
	color:var(--main-primary);
	text-decoration: underline;
}

.workspace-table i{
	font-size: 18px;
	cursor: pointer;
	margin: 0px 10px;
}

.workspace-table i.disabled{
	cursor: default;
	color: #ccc;
	pointer-events: none;
}

.workspace-table i.disabled:hover{
	cursor: default;
	color: #ccc;
}

.workspace-table i:hover{
	color: var(--accent-color);
}

.table-context-menu{
	width: 150px;
    position: absolute;
    display: none;
	border: 1px #CBCACA solid;
    background: #ffffff;
	box-shadow: 1px 1px #CCC;
	z-index: 999999;
}

.table-dropdown-menu{
	list-style: none;    
    padding: 10px;   
	color: #2D2D2D;
    font-weight: 600;
}

.table-dropdown-menu li{
	padding: 5px;
}

.table-dropdown-menu li.disabled{
	color: #ccc!important;
}

.table-dropdown-menu li.disabled:hover{
	background-color: #fff;
	cursor: default;
}

.table-dropdown-menu li:hover{
	background-color: #F5F5F5;
	cursor: pointer;
}

.table-dropdown-menu hr{
	margin: 10px 5px;
}

.share-button{
   height: 25px !important;
    padding: 2px 2px !important;
    position: absolute;
    font-size: 16px;
    color: #CCC;
    cursor: pointer;
    margin-top: 2px;
	background-color: #ffffff;
}

.share-button:hover{
	color: #2D2D2D;
}

.form-link-modal .link{
	margin-left: -22px;
}

.form-link-modal .open{
	margin-left: -43px;
}

.pf-icon-star-fill{
	color: var(--accent-color);
}

input.workspace-filter{
	height: 40px!important;
	border: 1px solid #c5c5c5;
	border-radius: 5px;
	display: block;
	padding: 0 4px 0 45px;
	font-size: 13px!important;
	font-family: Poppins;
}

input.workspace-filter:hover{
	cursor: pointer;
}

.icon-right:hover{
	cursor: pointer;
}

input.search-app, input.search-template {	
	width: 260px;
	background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_5___}) no-repeat 13px center;	
	cursor: text!important;
 }

 .search-wrapper {
	position: relative;
	width: min-content;
	float: left;
    margin-right: 5px;
  }

  .icon-right{
	position: absolute;
    right: 10px;
    font-size: 15px;
    font-weight: 600;
    color: #939393;
  }
  
  .clear-search, .clear-templ-search {
	top: 8px;
  }

  .caret-down{
	top: 16px;
  }

  .clear-search:hover, .clear-templ-search:hover{
	cursor: pointer;
  }


  input.filter-date-app {
	width: 190px;
	background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_6___}) no-repeat 13px center;
 }

 input.filter-status-app {	
	width: 120px;
    padding: 0 10px;
 }

 .context-menu{
	border-radius: 3px;
	border: 1px solid #CDCDCD;
	background: #FFF;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	position: absolute;
	z-index: 99999999;
	left: 5px;
	top: 50px;
	padding: 0 20px;
 }

.filter-arrow {
	border: solid #CDCDCD;
    border-width: 0 1px 1px 0;
    display: inline-block;
    padding: 6px;
    position: absolute;
    top: -7px;
    left: 12px;
	background-color: #fff;
  }

  .up {
	transform: rotate(-135deg);
	-webkit-transform: rotate(-135deg);
  }

  .filter-button:hover{
	cursor: pointer;
  }

  .filter-button{
	border-radius: 5px;
    border: 1px solid #cccccc;
    width: 190px;
    height: 40px;
    margin: 20px 0;
    font-size: 13px;
    text-align: center;
    padding: 10px 0;
    font-weight: 500;
	background: #FCFDFF;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);	
  }


  .filter-button.set{
	background: #F89B3C;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
	font-weight: 700;
	color: #ffffff;
 }



#template-gallery{
	font-family: Poppins;
	margin: 15px;
 }

 .gallery-title{
	font-weight: 500;
	font-size: 22px;
 }

 .template-categories{
	list-style: none;
	font-size: 16px;
	font-weight: 500;
	padding: 0 20px 0 0;
	margin: 0;
	color: #2D2D2D;
 }

 .template-categories li{
	margin: 10px 0;
 }

 .template-categories li a:hover{
	cursor: pointer;
	text-decoration: none;
	color: #2D2D2D;
 }

 .template-categories .selected{
	border-bottom: 2px solid #F89B3C;
 }

 .template-card{
	font-size: 14px;
	margin: 20px;
	position: relative;
	float: left;
	padding: 0 22px;
 }

 .template-card:hover{
	
	cursor: pointer;
 }

 .template-card .desktop{
	width: 300px; 
	height: 195px;
	border-radius: 10px;
	border: 6px solid #2D2D2D;
	background-color: red;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
 }

 .template-card .mobile{
	width:90px; 
	top: 65px;
    left: 260px;
	height: 150px;
	position: absolute;
	background-color: #2d84a4;
	border-radius: 10px;
	border: 6px solid #2D2D2D;
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
 }

 .template-card .name{
	margin: 15px 5px 5px 5px;
    font-weight: bold;
 }

 .template-card .category{
	margin: 5px;
	font-size: 13px;
 }


 .browse-button{
    margin: 0!important;
    padding: 0!important;
    width: 98%!important;
    display: flex!important;
	cursor: pointer;
 }

 .browse-button label{
	margin: 0!important;
	cursor: pointer;
 }

 .certificateExpired{
	color: red;
}

.truncate-text{
	white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
	width: 665px;
}

.refresh-wssource{
	font-size:24px;
}

.refresh-wssource:hover{
	cursor:pointer;
}

/* --- Modal window maximize icons --- */
.dialog-maximize-icon {
    float: right;
    margin-right: 5px; 
    cursor: pointer;

    font-size: 1.1em;
    margin-top: 2px;
    padding: 2px;

    color: #fff;
}

.dialog-maximize-icon:hover {
    opacity: 0.8;
}

/* --- jqGrid Bootstrap Override --- */
.jqgrid-table-override.ui-widget-content {
    border: none;
    background: none;
    box-shadow: none;
}

.jqgrid-table-override .ui-jqgrid-view {
    border: none;
	font-size: 13px;
	font-family: Poppins;
}

/* Style the main data table  */
.jqgrid-table-override .ui-jqgrid-bdiv .table {
    border: 1px solid #dee2e6;
}

/* Style the header wrapper */
.jqgrid-table-override .ui-jqgrid-hdiv {
    border: 1px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
    background: #f8f9fa; 
}

/* Style individual header cells */
.jqgrid-table-override .ui-th-column {
    border: none;
    font-weight: 600;
}

.jqgrid-table-override .ui-jqgrid-bdiv {
    overflow-x: hidden !important;
}

.jqgrid-table-override .ui-jqgrid-btable td {
	white-space: pre-line!important;
	overflow-wrap: break-word;
	height: auto;
	vertical-align: middle;
}

.fix-input-width{
	padding: 0 8px!important;
}

/* ========================================
   Vector Database - Linked Apps
   ======================================== */

.vectordb-linked-apps-section {
    margin-top: 15px;
}

.vectordb-linked-apps-list {
    min-height: 40px;
}

.vectordb-loading,
.vectordb-empty {
    color: #999;
    font-size: 12px;
    padding: 10px 0;
    font-style: italic;
}

.vectordb-linked-app-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 10px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    margin-bottom: 4px;
    background: #fff;
}

.vectordb-linked-app-row:hover {
    background: #f9f9f9;
}

.vectordb-app-info {
    display: flex;
    align-items: center;
    gap: 8px;
}

.vectordb-app-name {
    font-size: 12px;
    font-weight: 600;
    color: #333;
}

.vectordb-live-badge {
    background: #E8F5E9;
    color: #2E7D32;
    font-size: 10px;
    padding: 1px 6px;
    border-radius: 3px;
}

.vectordb-app-actions {
    display: flex;
    gap: 4px;
}

.vectordb-app-actions .btn {
    font-size: 11px;
}

.vectordb-linked-apps-actions {
    margin-top: 8px;
}

/* Vector DB Sync Progress */
.vectordb-sync-progress {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 180px;
}
.vectordb-sync-progress-bar-container {
    flex: 1;
    height: 8px;
    background: #e8e8e8;
    border-radius: 4px;
    overflow: hidden;
    min-width: 80px;
}
.vectordb-sync-progress-bar {
    height: 100%;
    background: #8eb934;
    border-radius: 4px;
    transition: width 0.3s ease;
}
.vectordb-sync-progress-text {
    font-size: 11px;
    color: #666;
    white-space: nowrap;
}
.vectordb-sync-progress-text .glyphicon {
    font-size: 10px;
    margin-right: 2px;
}
.vectordb-sync-info {
    font-size: 11px;
    color: #999;
    margin-left: 8px;
}

/* Danger Zone */
.vectordb-danger-zone {
    margin-top: 20px;
    border: 1px solid #e0b4b4;
    border-radius: 4px;
    padding: 12px 16px;
}
.vectordb-danger-zone h2 {
    color: #c9302c;
    margin-top: 0;
}
.vectordb-danger-zone-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.vectordb-danger-zone-info p {
    margin: 4px 0 0;
    color: #777;
    font-size: 12px;
}

/* Link App Dialog */
.vectordb-link-dialog-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.4);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.vectordb-link-dialog {
    background: #fff;
    border-radius: 6px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.2);
    width: 400px;
    max-width: 90%;
}

.vectordb-link-dialog-header {
    padding: 12px 16px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 14px;
}

.vectordb-link-dialog-body {
    padding: 16px;
}

.vectordb-link-dialog-body label {
    font-size: 12px;
    margin-bottom: 6px;
    display: block;
}

.vectordb-link-dialog-body select {
    width: 100%;
}

.vectordb-link-dialog-buttons {
    padding: 12px 16px;
    border-top: 1px solid #e8e8e8;
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.glyphicon-spin {
    animation: spin 1s infinite linear;
}

@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./assets/style/dashboard/pf.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;CACC;EACC,WAAW;CACZ;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,gCAAgC;CACjC;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,6BAA6B;EAC7B,qCAAqC;CACtC;;CAEA;EACC,6CAA6C;CAC9C;;CAEA;EACC,sBAAsB;CACvB;CACA;EACC,yBAAyB;EACzB,WAAW;EACX,aAAa;CACd;;CAEA;GACE,WAAW;CACb;;CAEA;;;;GAIE;AACH;;AAEA;CACC;EACC,sBAAsB;CACvB;;CAEA;EACC,yBAAyB;EACzB,sBAAsB;EACtB,8BAA8B;CAC/B;AACD;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,cAAc;QACd,WAAW;IACf;IACA;QACI,iCAAiC;EACvC,+CAA+C;IAC7C;IACA;EACF,MAAM;EACN,qBAAqB;CACtB;IACG;QACI,uBAAuB;IAC3B;IACA;QACI,qBAAqB;EAC3B,iBAAiB;CAClB;;CAEA;EACC,cAAc;CACf;CACA;QACO,WAAW;IACf;IACA;QACI,iBAAiB;QACjB,oBAAoB;IACxB;IACA;IACA,wBAAwB;CAC3B;AACD;AACA;CACC,kBAAkB;AACnB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAKA,eAAe;AACf;CACC,WAAW;CACX,SAAS;CACT,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;AACpC;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,iBAAiB;AAClB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,gCAAgC;CAChC,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;;AAEjB;;AAEA;;;;;CAKC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,mCAAmC;CACnC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,wBAAwB;CACxB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,yBAAyB;;CAEzB,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;;CAExB,WAAW;CACX,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,SAAS;CACT,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,qCAAqC;CACrC,WAAW;CACX,iBAAiB;AAClB;;;AAGA;CACC,eAAe;CACf,MAAM;CACN,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,cAAc;AACf;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;CAEC;EACC,iBAAiB;EACjB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,WAAW;EACX,qBAAqB;CACtB;;CAEA;EACC,kCAAkC;CACnC;;CAEA;EACC,kCAAkC;EAClC,WAAW;CACZ;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,0CAA0C;EAC1C,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,iBAAiB;CAClB;;CAEA;;;;;;GAME;;AAEH;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,0BAA0B;CAC1B,uBAAuB;AACxB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,iBAAiB;CACjB,qBAAqB;AACtB;AACA;CACC,qCAAqC;CACrC,kCAAkC;AACnC;AACA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,UAAU;IACP,WAAW;CACd,YAAY;CACZ,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;;AAGA,eAAe;AACf;CACC,eAAe;CACf,SAAS;CACT,WAAW;CACX,SAAS;CACT,iHAAiH;CACjH,mBAAmB,EAAE,iBAAiB;CACtC,iEAAiE,EAAE,aAAa;CAChF,mEAAmE,EAAE,4BAA4B;CACjG,iEAAiE,EAAE,qDAAqD;CACxH,mHAAmH,EAAE,UAAU;CAC/H,gCAAgC;CAChC,UAAU;CACV,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,UAAU;CACV,SAAS;CACT,UAAU;AACX;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,sBAAsB;CACtB,iBAAiB;CACjB,iBAAiB;AAClB;;;AAGA;CACC,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,6CAA6C;AAC9C;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;;EAEE;;AAEF;CACC,qBAAqB;AACtB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,qCAAqC;CACrC,kCAAkC;AACnC;;AAEA;CACC,yBAAyB;CACzB,wCAAwC;AACzC;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;;;;;CAKC;;AAED;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,qBAAqB;CACrB;AACD;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;;AAGA;CACC,4BAA4B;AAC7B;;AAEA;CACC,2BAA2B;AAC5B;;;AAGA,YAAY;AACZ;CACC,WAAW;CACX,eAAe;CACf,SAAS;CACT,gBAAgB;CAChB,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,4BAA4B;;CAE5B,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,WAAW;CACX,sBAAsB;CACtB,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,+BAA+B;KAClC,4BAA4B;KAC5B,2BAA2B;KAC3B,0BAA0B;KAC1B,uBAAuB;IACxB;AACJ;;AAEA;CACC;KACI;SACI,YAAY;SACZ,+BAA+B;MAClC,4BAA4B;MAC5B,2BAA2B;MAC3B,0BAA0B;MAC1B,uBAAuB;KACxB;CACJ;AACD;;AAEA;CACC;KACI;SACI,YAAY;SACZ,+BAA+B;MAClC,4BAA4B;MAC5B,2BAA2B;MAC3B,0BAA0B;MAC1B,uBAAuB;KACxB;CACJ;AACD;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,iCAAiC;CACjC,gBAAgB;AACjB;;AAEA;CACC,0CAA0C;CAC1C,kEAAkE;CAClE,qEAAqE;CACrE,sEAAsE;CACtE,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,mCAAmC;CACnC,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;;AAGA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,mCAAmC;CACnC,wCAAwC;CACxC,2CAA2C;AAC5C;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,eAAe;CACf,eAAe;CACf,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,UAAU;CACV,SAAS;CACT,cAAc;;CAEd,eAAe;CACf,iBAAiB;CACjB,mCAAmC;CACnC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gCAAgC;;CAEhC,WAAW;CACX,mCAAmC;CACnC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,eAAe;CACf,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,mCAAmC;CACnC,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;;CAEjB,kBAAkB;IACf,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB;;;aAGY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qCAAqC;CACrC,iBAAiB;AAClB;;AAEA,kBAAkB;AAClB;CACC,0BAA0B;CAC1B,8BAA8B;CAC9B,kBAAkB;CAClB,eAAe;CACf,8BAA8B;CAC9B,gDAAgD;CAChD,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA,+CAA+C;AAC/C;CACC,kCAAkC;AACnC;;AAEA,2BAA2B;AAC3B;CACC,eAAe;CACf,QAAQ;CACR,SAAS;CACT,YAAY;CACZ,0BAA0B;CAC1B,gBAAgB;CAChB,8BAA8B;CAC9B,YAAY;CACZ,aAAa;CACb,sBAAsB;CACtB,uCAAuC;AACxC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,iBAAiB;CACjB,wCAAwC;CACxC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,eAAe;CACf,cAAc;CACd,cAAc;CACd,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,OAAO;CACP,aAAa;CACb,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA,4CAA4C;AAC5C,wBAAwB;AACxB;CACC,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,UAAU;CACV,YAAY;CACZ,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,4BAA4B;AAC7B;;AAEA;;CAEC,wCAAwC;AACzC;;AAEA,0CAA0C;AAC1C;CACC,iBAAiB;CACjB,6BAA6B;AAC9B;;AAEA;CACC,wBAAwB;CACxB,sBAAsB;CACtB,YAAY;CACZ,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,OAAO;CACP,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;;;;;;CAMC;;AAED;CACC,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,6BAA6B;CAC7B,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;CACC,eAAe;CACf,yBAAyB;CACzB,0CAA0C;CAC1C,kEAAkE;CAClE,qEAAqE;CACrE,sEAAsE;AACvE;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,cAAc;;AAEd,sBAAsB;AACtB;CACC,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,wBAAwB;EACxB,sBAAsB;EACtB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB;AACD;;AAEA;CACC,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC;EACC,sBAAsB;CACvB;AACD;;AAEA;CACC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,eAAe;;AAEhB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,mCAAmC;EACnC,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,WAAW;AACb;;AAEA;CACC,WAAW;CACX,UAAU;IACP,SAAS;IACT,gBAAgB;;AAEpB;;AAEA;CACC,WAAW;GACT,UAAU;GACV,UAAU;GACV,eAAe;GACf,mBAAmB;AACtB;;AAEA;CACC,WAAW;GACT,UAAU;GACV,UAAU;GACV,eAAe;GACf,iBAAiB;;AAEpB;;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA,0BAA0B;AAC1B;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE;;AAEF;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,cAAc;AACf;;AAEA,oBAAoB;;AAEpB;;;;;;;;;;;;;;;;;;;CAmBC;;AAED;CACC,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;;CAEhB,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;;CAE/H;;0CAEyC;;CAEzC,yBAAyB;CACzB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,WAAW;AACZ;;AAEA,YAAY;AACZ;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;CAC1B,mCAAmC;CACnC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;;CAE/H,yBAAyB;;CAEzB,+BAA+B;CAC/B,oCAAoC;CACpC,uCAAuC;;CAEvC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;CACC,+BAA+B;CAC/B,uDAAuD;CACvD,0DAA0D;CAC1D,2DAA2D;;CAE3D,qCAAqC;;CAErC;;0CAEyC;;CAEzC,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,+BAA+B;CAC/B,uDAAuD;CACvD,0DAA0D;CAC1D,2DAA2D;CAC3D,qCAAqC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,gCAAgC;EAChC,kCAAkC;EAClC,eAAe;EACf,WAAW;AACb;;AAEA;CACC,iBAAiB;AAClB;;AAEA,eAAe;AACf;CACC,UAAU;CACV,wBAAwB;CACxB,kBAAkB;CAClB,uBAAuB;CACvB,0BAA0B;;CAE1B,yBAAyB;;CAEzB,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;;CAExB,cAAc;CACd,mCAAmC;CACnC,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,aAAa;CACb,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA,sBAAsB;;;AAGtB;CACC,WAAW;CACX,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;CACxB,2BAA2B;CAC3B,mBAAmB;CACnB,4BAA4B;CAC5B,cAAc;CACd,4BAA4B;CAC5B,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,cAAc;AACd;CACC,YAAY;AACb;;AAEA;CACC,mBAAmB,EAAE,iBAAiB;CACtC,+DAA+D,EAAE,aAAa;CAC9E,iEAAiE,EAAE,4BAA4B;CAC/F,+DAA+D,EAAE,qDAAqD;CACtH,mHAAmH;AACpH;;AAEA;CACC,mBAAmB,EAAE,iBAAiB;CACtC,+DAA+D,EAAE,aAAa;CAC9E,iEAAiE,EAAE,4BAA4B;CAC/F,+DAA+D,EAAE,qDAAqD;CACtH,mHAAmH;AACpH;;AAEA;CACC,mBAAmB,EAAE,iBAAiB;CACtC,+DAA+D,EAAE,aAAa;CAC9E,iEAAiE,EAAE,4BAA4B;CAC/F,+DAA+D,EAAE,qDAAqD;CACtH,mHAAmH;AACpH;;AAEA;;EAEE;;AAEF;GACG,qBAAqB;GACrB,oBAAoB;AACvB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,6BAA6B;CAC7B,4BAA4B;AAC7B;;;AAGA;CACC,4BAA4B;AAC7B;;AAEA;;;;;EAKE;;AAEF,6BAA6B;AAC7B,eAAe,YAAY,EAAE;AAC7B,sBAAsB,gBAAgB,CAAC;AACvC,qBAAqB,oBAAoB,CAAC;AAC1C;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B,EAAE,oCAAoC;OAClE,4BAA4B,EAAE,iBAAiB;QAC9C,2BAA2B,EAAE,sBAAsB;SAClD,0BAA0B,EAAE,iBAAiB;YAC1C,uBAAuB;AACnC;AACA;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,iBAAiB;AACjB;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,oCAAoC;AACpC;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,sBAAsB;AACtB;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,iBAAiB;AACjB;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,uCAAuC;IACvC,kCAAkC;IAClC,gBAAgB;;IAEhB,8BAA8B,EAAE,oCAAoC;OACjE,2BAA2B,EAAE,iBAAiB;QAC7C,0BAA0B,EAAE,sBAAsB;SACjD,yBAAyB,EAAE,iBAAiB;YACzC,sBAAsB;AAClC;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,iBAAiB;AACjB;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,oCAAoC;AACpC;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,sBAAsB;AACtB;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA,iBAAiB;AACjB;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;;;AAIA,cAAc;AACd;;IAEI,iBAAiB;IACjB,gCAAgC;AACpC;;;AAGA,WAAW;;AAEX;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,SAAS;CACT,YAAY;AACb;;AAEA;CACC,cAAc;;CAEd,iBAAiB;CACjB,UAAU;CACV,SAAS;CACT,cAAc;CACd,cAAc;;CAEd,mBAAmB,EAAE,iBAAiB;CACtC,gEAAgE,EAAE,aAAa;CAC/E,kEAAkE,EAAE,4BAA4B;CAChG,gEAAgE,EAAE,qDAAqD;CACvH,mHAAmH,EAAE,UAAU;;CAE/H,eAAe;;AAEhB;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,iBAAiB;CACjB,eAAe;CACf,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,QAAQ;CACR,WAAW;AACZ;;;AAGA;CACC,UAAU;CACV,oCAAoC;CACpC,+CAA+C;CAC/C,oDAAoD;CACpD,uDAAuD;CACvD,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,oCAAoC;CACpC,gDAAgD;CAChD,qDAAqD;CACrD,wDAAwD;CACxD,WAAW;AACZ;;AAEA;CACC,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,oCAAoC;CACpC,+CAA+C;CAC/C,oDAAoD;CACpD,uDAAuD;CACvD,WAAW;AACZ;;AAEA;CACC,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,UAAU;CACV,yBAAyB;CACzB,gDAAgD;CAChD,qDAAqD;CACrD,wDAAwD;CACxD,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,cAAc;AACf;;AAEA;CACC,yBAAyB;CACzB,8CAA8C;CAC9C,mDAAmD;CACnD,sDAAsD;CACtD,WAAW;AACZ;;AAEA;CACC,kCAAkC;CAClC,cAAc;AACf;;AAEA,QAAQ;AACR;CACC,gBAAgB;CAChB,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA,6CAA6C;AAC7C,wCAAwC,8BAA8B,EAAE;AACxE,iCAAiC,8BAA8B,EAAE;;;AAGjE,oEAAoE;AACpE;KACK,cAAc;AACnB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;CACC;AACD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,cAAc;CACd,SAAS;CACT,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,cAAc;CACd,SAAS;CACT,iBAAiB;CACjB,eAAe;AAChB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;;CAGC,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;;CAGC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,6BAA6B;CAC7B,oBAAoB;CACpB,kBAAkB;CAClB,oBAAoB;CACpB,gBAAgB;CAChB,4BAA4B;CAC5B,eAAe;AAChB;AACA;CACC,wDAA8D;AAC/D;AACA;CACC,wDAA+D;AAChE;AACA;CACC,wDAA6D;AAC9D;AACA;CACC,wDAAkE;AACnE;AACA;CACC,wDAAkE;AACnE;;AAEA;IACI,YAAY;AAChB;;AAEA;CACC,kBAAkB,EAAE,OAAO,EAAE;AAC9B;;AAEA;CACC,mBAAmB;IAChB,WAAW;AACf;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;AACA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;IACI,gFAAiF;EACnF;;AAEF;IACI,iBAAiB;IACjB,gBAAgB;IAChB,iCAAiC;CACpC,kBAAkB;CAClB,eAAe;AAChB;EACE;;IAEE;AACJ;IACI,aAAa;AACjB;AACA;CACC;AACD;;AAEA;CACC,qDAAqD;AACtD;;AAEA,UAAU;AACV;CACC,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB,EAAE,WAAW,EAAE,uBAAuB;AAC1D;;AAEA;CACC,sBAAsB,EAAE,WAAW,EAAE,uBAAuB;AAC7D;;AAEA;CACC,sBAAsB,EAAE,WAAW;AACpC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,mBAAmB,EAAE,WAAW;AACjC;;AAEA,wBAAwB;AACxB;CACC;EACC,aAAa;EACb,mBAAmB;CACpB;AACD;AACA,wBAAwB;;AAExB,oCAAoC;AACpC;CACC,0BAA0B;AAC3B;;;AAGA,gDAAgD;AAChD;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;AACV;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;IACf,sBAAsB;AAC1B;AACA,sBAAsB;;AAEtB;CACC,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;AAChB;;AAEA;IACI,eAAe;AACnB;;;AAGA,kBAAkB;AAClB;CACC,yBAAyB;CACzB,wBAAwB;CACxB,sBAAsB;CACtB,oBAAoB;CACpB,iBAAiB;CACjB,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;IAClB,WAAW;IACX,iCAAiC;IACjC,kBAAkB;IAClB,+DAA+D;IAC/D,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;CAC1B,sBAAsB;CACtB,iCAAiC;AAClC;;AAEA;CACC,0BAA0B;CAC1B,sCAAsC;AACvC;;AAEA;CACC,2BAA2B;CAC3B,sCAAsC;AACvC;;AAEA;CACC,2BAA2B;AAC5B;;;AAGA,6BAA6B;AAC7B;CACC,oBAAoB;AACrB;;AAEA;CACC,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,eAAe;AAC7E;;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;CAClB,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA,UAAU;;AAEV;CACC,YAAY;GACV,gBAAgB;AACnB;;AAEA;CACC,iBAAiB;CACjB,WAAW;AACZ;AACA;;CAEC,oCAAoC;CACpC,iCAAiC;CACjC,8BAA8B;CAC9B,qBAAqB;CACrB,SAAS;CACT,UAAU;CACV,mBAAmB;CACnB,QAAQ;;AAET;AACA;;CAEC,WAAW;AACZ;;AAEA;CACC,iBAAiB;AAClB;AACA;CACC,KAAK;CACL,SAAS;CACT,eAAe;CACf,gBAAgB;CAChB,mCAAmC;CACnC,gCAAgC;CAChC,2BAA2B;AAC5B;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;CACb,WAAW;CACX,WAAW;CACX,OAAO;CACP,QAAQ;CACR,wBAAwB;CACxB,kBAAkB;CAClB,0BAA0B;CAC1B,yBAAyB;CACzB,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;CACV,gBAAgB;CAChB,mCAAmC;CACnC,gCAAgC;CAChC,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,sBAAsB;CACtB,kBAAkB;CAClB,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;;AAGA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,oBAAoB;CACpB,oBAAoB;AACrB;;AAEA;CACC;EACC,oBAAoB;CACrB;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;IACf,gBAAgB;AACpB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,WAAW;IACR,qCAAqC;IACrC,YAAY;CACf,cAAc;CACd,eAAe;CACf,kBAAkB;IACf,eAAe;AACnB;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,eAAe;IACZ,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,iBAAiB;CACpB,YAAY;CACZ,oBAAoB;AACrB;;AAEA;CACC,iBAAiB;CACjB,WAAW;AACZ;;AAEA;CACC,WAAW;IACR,gBAAgB;AACpB;;AAEA;CACC,2BAA2B;IACxB,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,gBAAgB;IACb,+CAA+C;CAClD,UAAU;AACX;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,aAAa;CACb,eAAe;CACf,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,UAAU;AACX;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;IAChB,2BAA2B;CAC9B,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;IAC3B,0BAA0B;AAC9B;;AAEA;CACC,4BAA4B;IACzB,6BAA6B;IAC7B,YAAY;IACZ,0BAA0B;IAC1B,+CAA+C;IAC/C,WAAW;CACd,kBAAkB;IACf,sBAAsB;AAC1B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,4BAA4B;IACzB,6BAA6B;IAC7B,YAAY;IACZ,0BAA0B;IAC1B,+CAA+C;IAC/C,WAAW;CACd,gBAAgB;IACb,sBAAsB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qCAAqC;IAClC,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;CACC,WAAW;CACX,WAAW;CACX,yBAAyB;AAC1B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;IACtB,iBAAiB;CACpB,eAAe;CACf,oBAAoB;CACpB,mBAAmB;CACnB,+BAA+B;CAC/B,eAAe;AAChB;;AAEA;CACC,oCAAoC;IACjC,WAAW;IACX,6BAA6B;IAC7B,4BAA4B;IAC5B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;CACnB,oBAAoB;AACrB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,qCAAqC;IAClC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;CAClC,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;CAClC,oBAAoB;CACpB,gBAAgB;CAChB,gBAAgB;CAChB,eAAe;;CAEf,uCAAuC;AACxC;;AAEA;CACC,iGAAiG;AAClG;;AAEA;IACI,iGAAiG;AACrG;;AAEA;CACC,gEAAgE;CAChE,yBAAyB;CACzB,cAAc;AACf;;AAEA;IACI,gEAAgE;CACnE,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;CACC,WAAW;IACR,mBAAmB;CACtB,WAAW;IACR,iBAAiB;AACrB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;IAChB,qCAAqC;IACrC,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;CACC,mBAAmB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;IACb,eAAe;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA;CACC,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,WAAW;CACX,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;IACT,kBAAkB;IAClB,aAAa;CAChB,yBAAyB;IACtB,mBAAmB;CACtB,wBAAwB;CACxB,eAAe;AAChB;;AAEA;CACC,gBAAgB;IACb,aAAa;CAChB,cAAc;IACX,gBAAgB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,eAAe;AAChB;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;GACG,uBAAuB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;IACf,eAAe;CAClB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;CACd,qBAAqB;CACrB,yBAAyB;CACzB,oBAAoB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,qFAA8F;CAC9F,sBAAsB;CACtB;;CAEA;CACA,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;IACR,iBAAiB;EACnB;;EAEA;CACD,kBAAkB;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;CACD,QAAQ;EACP;;EAEA;CACD,SAAS;EACR;;EAEA;CACD,eAAe;EACd;;;EAGA;CACD,YAAY;CACZ,qFAAkG;CAClG;;CAEA;CACA,YAAY;IACT,eAAe;CAClB;;CAEA;CACA,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,+CAA+C;CAC/C,kBAAkB;CAClB,iBAAiB;CACjB,SAAS;CACT,SAAS;CACT,eAAe;CACf;;AAED;CACC,qBAAqB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;CACb,sBAAsB;EACrB;;EAEA;CACD,0BAA0B;CAC1B,kCAAkC;EACjC;;EAEA;CACD,eAAe;EACd;;EAEA;CACD,kBAAkB;IACf,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,gBAAgB;CACnB,mBAAmB;CACnB,+CAA+C;EAC9C;;;EAGA;CACD,mBAAmB;CACnB,qDAAqD;CACrD,gBAAgB;CAChB,cAAc;CACd;;;;AAID;CACC,oBAAoB;CACpB,YAAY;CACZ;;CAEA;CACA,gBAAgB;CAChB,eAAe;CACf;;CAEA;CACA,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd;;CAEA;CACA,cAAc;CACd;;CAEA;CACA,eAAe;CACf,qBAAqB;CACrB,cAAc;CACd;;CAEA;CACA,gCAAgC;CAChC;;CAEA;CACA,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf;;CAEA;;CAEA,eAAe;CACf;;CAEA;CACA,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,qBAAqB;CACrB,+CAA+C;CAC/C;;CAEA;CACA,UAAU;CACV,SAAS;IACN,WAAW;CACd,aAAa;CACb,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,yBAAyB;CACzB,+CAA+C;CAC/C;;CAEA;CACA,wBAAwB;IACrB,iBAAiB;CACpB;;CAEA;CACA,WAAW;CACX,eAAe;CACf;;;CAGA;IACG,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,uBAAuB;CAC1B,eAAe;CACf;;CAEA;CACA,mBAAmB;CACnB,eAAe;CACf;;CAEA;CACA,UAAU;AACX;;AAEA;CACC,mBAAmB;IAChB,gBAAgB;IAChB,uBAAuB;CAC1B,YAAY;AACb;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA,wCAAwC;AACxC;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;;IAEf,gBAAgB;IAChB,eAAe;IACf,YAAY;;IAEZ,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA,sCAAsC;AACtC;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;CACf,eAAe;CACf,oBAAoB;AACrB;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;AAC7B;;AAEA,6BAA6B;AAC7B;IACI,yBAAyB;IACzB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;CACC,+BAA+B;CAC/B,yBAAyB;CACzB,YAAY;CACZ,sBAAsB;AACvB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;6CAE6C;;AAE7C;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,sCAAsC;IACtC,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,OAAO,uBAAuB,EAAE;IAChC,KAAK,yBAAyB,EAAE;AACpC","sourcesContent":["/*Bootstrap Override*/\r\n@media (min-width: 1200px) {\r\n\tnav .container, header .container {\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.right-nav {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\t.navbar-default .navbar-nav .open .dropdown-menu>li>a, .navbar-default .navbar-nav .open .dropdown-menu>li>a:hover {\r\n\t\tcolor: #fff;\r\n\t}\r\n\r\n\t.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover {\r\n\t\tbackground: #c72328;\r\n\t}\r\n\r\n\t.navbar-default .navbar-nav .open .dropdown-toggle {\r\n\t\twidth: 100%;\r\n\t}\r\n\r\n\t.navbar-default .navbar-nav .open {\r\n\t\tborder-bottom: 1px solid #c72328;\r\n\t}\r\n\r\n\t.dashboard-left-rail {\r\n\t\twidth: 240px !important;\r\n\t}\r\n\r\n\t.content-wrap {\r\n\t\tmargin-left: 240px !important;\r\n\t\twidth: calc(100vw - 240px) !important;\r\n\t}\r\n\r\n\t.ai-panel-open .content-wrap {\r\n\t\twidth: calc(100vw - 240px - 380px) !important;\r\n\t}\r\n\r\n\t.action-buttons .pull-left, .action-buttons .pull-right {\r\n\t\tfloat: none !important;\r\n\t}\r\n\t.action-buttons .btn, .action-buttons .btn-default {\r\n\t\tdisplay: block !important;\r\n\t\twidth: 100%;\r\n\t\tmargin: 5px 0;\r\n\t}\r\n\r\n\t.action-buttons .open > .dropdown-menu {\r\n\t  width: 100%;\r\n\t}\r\n\r\n\t/*.btn-primary, .btn-default {\r\n\t\tdisplay: block;\r\n\t\twidth: 100%;\r\n\t\tmargin-bottom: 15px;\r\n\t}*/\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n\t.dashboard-left-rail-scroll {\r\n\t\theight: 87% !important;\r\n\t}\r\n\r\n\t.btn-primary, .btn-default {\r\n\t\tdisplay: block !important;\r\n\t\twidth: 100% !important;\r\n\t\tmargin-bottom: 15px !important;\r\n\t}\r\n}\r\n@media (max-width: 1200px) {\r\n    .navbar-header {\r\n        float: none;\r\n    }\r\n    .navbar-left,.navbar-right {\r\n        float: none !important;\r\n    }\r\n    .navbar-toggle {\r\n        display: block;\r\n        float: left;\r\n    }\r\n    .navbar-collapse {\r\n        border-top: 1px solid transparent;\r\n\t\tbox-shadow: inset 0 1px 0 rgba(255,255,255,0.1);\t\t\r\n    }\r\n    .navbar-fixed-top {\r\n\t\ttop: 0;\r\n\t\tborder-width: 0 0 1px;\r\n\t}\r\n    .navbar-collapse.collapse {\r\n        display: none!important;\r\n    }\r\n    .navbar-nav {\r\n        float: none!important;\r\n\t\tmargin-top: 7.5px;\r\n\t}\r\n\t\r\n\t.right-nav {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.navbar-nav>li {\r\n        float: none;\r\n    }\r\n    .navbar-nav>li>a {\r\n        padding-top: 10px;\r\n        padding-bottom: 10px;\r\n    }\r\n    .collapse.in{\r\n  \t\tdisplay:block !important;\r\n\t}\r\n}\r\n.navbar-brand {\r\n\tpadding: 10px 15px;\r\n}\r\n.reveal .fa {\r\n  font-family: 'FontAwesome';\r\n  font-style: normal;\r\n}\r\n\r\n@import url(https://fonts.googleapis.com/css?family=Roboto:400,300,500,700,900);\r\n@import url(https://fonts.googleapis.com/css?family=Poppins:400,300,500,700,900);\r\n\r\n/* Hard Reset */\r\nhtml, body {\r\n\theight:100%;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tposition: relative;\r\n}\r\n\r\nhtml {\r\n\tfont-size: 62.5%;\r\n\t-webkit-font-smoothing: antialiased;\r\n}\r\n\r\nbody {\r\n\tbackground: #fff;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\toverflow-y: auto;\r\n\toverflow-x: hidden;\r\n}\r\n\r\nh1 {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tcolor: #333;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 2.5rem;\r\n}\r\n\r\n#dashboard-main-panel, #dashboard-main-panel .form-instances,\r\n#dashboard-main-panel .dropdown .dropdown-menu li {\r\n\tfont-size: 11px;\r\n}\r\n\r\n#dashboard-main-panel h2 {\r\n\tpadding-bottom: 5px;\r\n\tborder-bottom: 1px solid #d5d5d5;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 24px;\r\n\tfont-size: 1.75rem;\r\n\tfont-weight: 500;\r\n\t\r\n}\r\n\r\n#dashboard-main-panel .form-horizontal select, \r\n#dashboard-main-panel input[type=\"text\"], input[type=\"password\"], \r\n#dashboard-main-panel #actionGeneral select, #main-panel-rol, .main-panel-combo, \r\n#dashboard-main-panel loginSection select, \r\n.advanced-user-signup select, input[type=\"text\"] {\r\n\theight: 25px;\r\n\tfont-size: inherit;\r\n} \r\n\r\nh2 small, caption {\r\n\tfont-size: 18px;\r\n\tcolor: #333;\r\n\tfont-weight: bold;\r\n}\r\n\r\nh3 {\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 16px;\r\n\tfont-size: 1.6rem;\r\n\tfont-weight: 500;\r\n}\r\n\r\nh4 {\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 16px;\r\n\tfont-size: 1.6rem;\r\n\tfont-weight: 500;\r\n}\r\n\r\na, a:hover {\r\n\tcolor: var(--main-primary);\r\n}\r\n\r\nlabel {\r\n\tfont-weight: normal;\r\n}\r\n\r\ninput[type=\"text\"], input[type=\"password\"], input[type=\"numeric\"], textarea {\r\n\twidth: 100%;\r\n\tpadding: 5px 2px 5px 8px;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\t\r\n\tborder: 1px solid #d5d5d5;\r\n\t\r\n\tbox-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\t-webkit-box-shadow: none;\r\n\t\r\n\tcolor: #333;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 400;\r\n}\r\n\r\n#dashboard-main-panel textarea {\r\n\tmin-height: 400px !important;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n#connectionSection #bindUser {\r\n\tmin-height: 100px !important;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n#connectionSection #contextDN {\r\n\tmin-height: 100px !important;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\n#connectionSection #filter {\r\n\tmin-height: 100px !important;\r\n\tmargin-bottom: 15px;\r\n}\r\n\r\ntextarea:focus {\r\n\toutline: none;\r\n}\r\n\r\ninput[type=\"text\"]:focus {\r\n\tcolor: #333333;\r\n\toutline: none;\r\n\tborder-color: #bbb;\r\n\tbox-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\t-webkit-box-shadow: none;\r\n}\r\n\r\nul.list {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\nul.list li {\r\n\tmargin: 0;\r\n\tpadding: 0.3rem 0;\r\n\tlist-style: none;\r\n}\r\n\r\nul.list li a {\r\n\tcolor: var(--main-primary);\r\n}\r\n\r\n.badge {\r\n\tbackground-color: var(--main-primary);\r\n\tcolor: #fff;\r\n\tfont-size: 1.6rem;\r\n}\r\n\r\n\r\nheader.dashboard {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\twidth: 100%;\r\n\theight: 50px;\r\n\tbackground: #fff;\r\n\tfont-size: 16px;\r\n\tfont-size: 1.3rem;\r\n\tz-index: 2; \r\n}\r\n\r\n.topbar {\r\n\tz-index: 99997;\r\n}\r\n.dropdown.bootstrapMenu.designer-context-menu{\r\n  top:20% !important;\r\n  width: 170px !important;\r\n}\r\n\r\n\theader.dashboard .nav li a {\r\n\t\tpadding: 5px 10px;\r\n\t\tbackground: transparent;\r\n\t\tfont-size: 15px;\r\n\t\tfont-size: 1.5rem;\r\n\t\tfont-family: \"Roboto\", \"sans-serif\";\r\n\t\tfont-weight: 500;\r\n\t\tcolor: #333;\r\n\t\ttext-decoration: none;\r\n\t}\r\n\t\r\n\theader.dashboard .nav li a:hover {\r\n\t\tbackground: transparent !important;\r\n\t}\r\n\t\r\n\theader.dashboard .nav .open > a, header .nav .open > a:hover, header.nav .open > a:focus, header.nav .open > a:visited {\r\n\t\tbackground: transparent !important;\r\n\t\tborder: 0px;\r\n\t}\r\n\t\r\n\theader.dashboard .nav .dropdown .dropdown-menu a {\r\n\t\tfont-weight: 400;\r\n\t}\r\n\t\r\n\theader.dashboard .nav .dropdown .dropdown-menu a:hover {\r\n\t\tbackground: var(--main-primary) !important;\r\n\t\tcolor: #fff;\r\n\t}\r\n\t\r\n\theader.dashboard .navbar-nav li a i {\r\n\t\tfont-size: 16px;\r\n\t\tfont-size: 1.6rem;\r\n\t}\r\n\r\n\t/*header .header-menu li a:hover {\r\n\t\tcolor: #799f2c;\r\n\t}\r\n\r\n\theader .header-menu i {\r\n\t\tfont-size: 24px;\r\n\t}*/\r\n\r\n.user-details {\r\n\tmargin-top: 11px;\r\n\tmargin-right: 7px;\r\n}\r\n\r\n.thumb-md {\r\n\tdisplay: inline-block;\r\n\theight: 36px;\r\n\twidth: 36px;\r\n\tmargin-right: 10px;\r\n}\r\n\r\n.img-circle {\r\n\tborder-radius: 50%;\r\n\t-webkit-border-radius: 50%;\r\n\t-moz-border-radius: 50%;\r\n}\r\n\r\n.user-details .dropdown {\r\n\tmargin-top: 5px;\r\n}\r\n\r\n.user-details .dropdown-toggle {\r\n\tborder: 0px;\r\n\tcolor: #000;\r\n\tfont-weight: bold;\r\n}\r\n\r\n.user-details .dropdown-toggle .caret {\r\n\tmargin-left: 5px;\r\n\tmargin-top: 10px;\r\n}\r\n\r\n.user-details .dropdown-toggle:hover, .user-details .dropdown-toggle:active, .user-details .dropdown-toggle:visited {\r\n\ttext-decoration: none;\r\n}\r\n.user-details a {\r\n\tcolor: #333333;\r\n\tfont-size: 1.3rem;\r\n\tfont-weight: bold;\r\n\ttext-decoration: none;\r\n}\r\n.user-details a:hover {\r\n\tcolor: var(--main-primary) !important;\r\n\tbackground: transparent !important;\r\n}\r\n.user-details .dropdown-menu a:hover {\r\n\tbackground-color: #fa2b31;\r\n\tcolor: #fff;\r\n}\r\n\r\n.navbar-brand {\r\n\theight: auto;\r\n\ttext-align: center;\r\n\tpadding: 0;\r\n    width: auto;\r\n\theight: 41px;\r\n\tmargin-left: -5px;\r\n\tmargin-top: 2px;\r\n}\r\n\r\n.navbar-brand label {\r\n\tfloat: right;\r\n\tfont-size: 10px;\r\n\tmargin-top: 29px;\r\n\tcolor: #aaa;    \r\n\tmargin-right: 5px;\r\n\tmargin-left: 5px;\r\n}\r\n\t\r\n.navbar-brand img {\r\n\tdisplay: inline;\r\n}\r\n\r\n\r\n/* Navigation */\r\n.navbar-default {\r\n\tposition: fixed;\r\n\ttop: 41px;\r\n\twidth: 100%;\r\n\tmargin: 0;\r\n\t/* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#fcfcfc+38,eeeeee+100 */\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 38%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 38%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 38%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\tborder-bottom: 1px solid #e4e5e5;\r\n\tz-index: 1;\r\n\tmin-height: 40px;\r\n\tmargin-top: 5px;\r\n}\r\n\r\n.right-nav {\r\n\tposition: absolute;\r\n\ttop: 1px;\r\n\tright: 5px;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n}\r\n\r\n.navbar-default .navbar-nav>li>a, .right-nav > li > a {\r\n\tdisplay: inline-block;\r\n\tpadding: 10px 10px;\r\n\tcolor: #333 !important;\r\n\tfont-size: 1.4rem;\r\n\tfont-weight: bold;\r\n}\r\n\r\n\r\n.navbar-default .navbar-nav>li>a.help, .right-nav > li > a.help {\r\n\tmargin-top: 3px;\r\n\tpadding: 3px 7px;\r\n\tcolor: white !important;\r\n\tfont-weight: normal;\r\n\tfont: normal normal normal 11px/1 FontAwesome;\r\n}\r\n\r\n.right-nav li {\r\n\tdisplay: inline-block;\r\n\tlist-style: none;\r\n\tpadding-right: 22px;\r\n}\r\n\r\n/*.right-nav li:last-child {\r\n\tpadding-right: 5px;\r\n}*/\r\n\r\n.right-nav > li > a:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n.right-nav > li > a.help {\r\n\tmargin-top: -1px !important;\r\n}\r\n\r\n.right-nav > li.refresh-report > a {\r\n\tpadding-top: 12px;\r\n}\r\n\r\n.navbar-default .navbar-nav>li>a>i {\r\n\tmargin-right: 5px;\r\n\tfont-weight: normal;\r\n}\r\n\r\n.navbar-default .navbar-nav>li>a:hover, .navbar-default .navbar-nav>li.active>a, .navbar-default .navbar-nav>li.active>a:hover {\r\n\tcolor: var(--main-primary) !important;\r\n\tbackground: transparent !important;\r\n}\r\n\r\n.navbar-default .navbar-toggle, .navbar-default .navbar-toggle:hover, .navbar-default .navbar-toggle:visited, .navbar-default .navbar-toggle:active {\r\n\tborder-color: transparent;\r\n\tbackground-color: transparent !important;\r\n}\r\n\r\n.navbar-default .navbar-toggle .icon-bar {\r\n\tbackground-color: #333;\r\n}\r\n\r\n.navbar-default .navbar-brand {\r\n\tpadding-top: 20px;\r\n\tcolor: #333;\r\n}\r\n\r\n.navbar-default .navbar-nav>.open>a, .navbar-default .navbar-nav>.open>a:focus, .navbar-default .navbar-nav>.open>a:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #c72328;\r\n}\r\n\r\n.navbar-default .navbar-nav>.open>a:visited, .navbar-default .navbar-nav>.open>a:active {\r\n\tcolor: #fff;\r\n}\r\n\r\n.navbar-default .dropdown-toggle {\r\n\tbackground: transparent;\r\n\tborder: transparent;\r\n\tborder-radius: 0px;\r\n\t-moz-border-radius: 0px;\r\n\t-webkit-border-radius: 0px;\r\n}\r\n\r\n.navbar-default .dropdown-menu {\r\n\tbackground-color: #c72328;\r\n}\r\n\r\n.navbar-default .dropdown-menu>li>a {\r\n\tcolor: #fff;\r\n}\r\n\r\n.navbar-default .dropdown-menu>li>a:hover {\r\n\tbackground-color: #fa2b31;\r\n\tcolor: #fff;\r\n}\r\n\r\n/*\r\n.col-xs-1, .col-sm-1, .col-md-1, .col-lg-1, .col-xs-2, .col-sm-2, .col-md-2, .col-lg-2, .col-xs-3, .col-sm-3, .col-md-3, .col-lg-3, .col-xs-4, .col-sm-4, .col-md-4, .col-lg-4, .col-xs-5, .col-sm-5, .col-md-5, .col-lg-5, .col-xs-6, .col-sm-6, .col-md-6, .col-lg-6, .col-xs-7, .col-sm-7, .col-md-7, .col-lg-7, .col-xs-8, .col-sm-8, .col-md-8, .col-lg-8, .col-xs-9, .col-sm-9, .col-md-9, .col-lg-9, .col-xs-10, .col-sm-10, .col-md-10, .col-lg-10, .col-xs-11, .col-sm-11, .col-md-11, .col-lg-11, .col-xs-12, .col-sm-12, .col-md-12, .col-lg-12 {\r\n\tpadding-left: 0;\r\n\tpadding-right: 0;\r\n}\r\n*/\r\n\r\n.form-horizontal .form-group {\r\n\tmargin-left: 0;\r\n\tmargin-right: 0;\r\n}\r\n\r\n.radio input[type=\"radio\"], .radio-inline input[type=\"radio\"], .checkbox input[type=\"checkbox\"], .checkbox-inline input[type=\"checkbox\"] {\r\n\tmargin-left: -19px;\r\n}\r\n\r\n.form-group-flex {\r\n\tdisplay: -ms-flexbox;      \r\n\tdisplay: -webkit-flex;\r\n\tdisplay: flex\r\n}\r\n\r\n.form-group-label {\r\n\tmargin-top: 3px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.form-group-text {\r\n\tmargin-top: 5px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n\r\n.form-radio-group {\r\n\tmargin-right: 2px !important;\r\n}\r\n\r\n.form-radio-group-left {\r\n\tmargin-left: 1px !important;\r\n}\r\n\r\n\r\n/* Sidebar */\r\n.dashboard-left-rail {\r\n\tfloat: left;\r\n\tposition: fixed;\r\n\ttop: 80px;\r\n\tmax-width: 250px;\r\n\twidth: 250px;\r\n\theight: 100%;\t\r\n\theight: 100vh;\r\n\tpadding: 15px 0px 130px;\r\n\tbackground: #f9f9f9;\r\n\tborder-right: 1px solid #ddd;\r\n\t\r\n\ttransition: margin-left .3s ease;\r\n}\r\n\r\n.dashboard-left-rail-scroll {\r\n\twidth: 100%;\r\n\theight: 94%;\r\n\tmargin: -10px 0 -100px;\r\n\tpadding: 0px 0px 100px 0;\r\n\toverflow-y: auto;\r\n}\r\n\r\n@-moz-document url-prefix() {\r\n    .dashboard-left-rail-scroll {\r\n        height: 82vh;\r\n        -webkit-transition: height 0.5s; \r\n\t    -moz-transition: height 0.5s; \r\n\t    -ms-transition: height 0.5s; \r\n\t    -o-transition: height 0.5s; \r\n\t    transition: height 0.5s; \r\n    }\r\n}\r\n\r\n@media screen and (max-height: 1090px) {\r\n\t@-moz-document url-prefix() {\r\n\t    .dashboard-left-rail-scroll {\r\n\t        height: 77vh;\r\n\t        -webkit-transition: height 0.5s; \r\n\t\t    -moz-transition: height 0.5s; \r\n\t\t    -ms-transition: height 0.5s; \r\n\t\t    -o-transition: height 0.5s; \r\n\t\t    transition: height 0.5s;\r\n\t    }\r\n\t}\r\n}\r\n\r\n@media screen and (max-height: 980px) {\r\n\t@-moz-document url-prefix() {\r\n\t    .dashboard-left-rail-scroll {\r\n\t        height: 68vh;\r\n\t        -webkit-transition: height 0.5s; \r\n\t\t    -moz-transition: height 0.5s; \r\n\t\t    -ms-transition: height 0.5s; \r\n\t\t    -o-transition: height 0.5s; \r\n\t\t    transition: height 0.5s;\r\n\t    }\r\n\t}\r\n}\r\n\r\n.dashboard-left-rail .btn-default {\r\n\tmargin-right: 0px;\r\n}\r\n\r\n.action-buttons {\r\n\tmargin: 0 auto 1.5rem;\r\n\tpadding: 0 15px;\r\n}\r\n\r\n.document-group {\r\n\tmargin: 5px 0 0;\r\n}\r\n\r\n.document.dashboard > .document-heading {\r\n\tpadding: 1px 15px;\r\n\t/*border-top: 1px solid #d5d5d5;*/\r\n\toverflow: hidden;\r\n}\r\n\r\n.document.dashboard.active > .document-heading {\r\n\tbackground: var(--main-primary) !important;\r\n\tbackground-image: -moz-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n\tborder-top: 0px;\r\n\tcolor: #fff;\r\n}\r\n\r\n.document.dashboard > .document-heading > h4 {\r\n\tfloat: left;\r\n\tmargin-top: 9px;\r\n\tmargin-left: 0px;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 500;\r\n\tfont-size: 18px;\r\n\tfont-size: 1.4rem;\r\n\tletter-spacing: 0.2px;\r\n}\r\n\r\n.document.dashboard > .document-heading > h4 > a {\r\n\tcolor: #333;\r\n}\r\n\r\n.document.dashboard > .document-heading > h4 > a:visited, .document.dashboard > .document-heading > h4 > a:active {\r\n\ttext-decoration: none !important;\r\n}\r\n\r\n.document.dashboard > .document-heading > h4 > a:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n\r\n.document.dashboard.active > .document-heading > h4 > a {\r\n\tcolor: #fff;\r\n}\r\n\r\n.document.dashboard > .document-heading .switch {\r\n\tfloat: right;\r\n\tmargin: 7px 0;\r\n}\r\n\r\n.document.dashboard > .document-heading > .switch > .pf {\r\n\tcolor: #333;\r\n\tfont-size: 14px;\r\n\tfont-weight: normal;\r\n}\r\n\r\n.document.dashboard.active > .document-heading > .switch > .pf {\r\n\tcolor: #fff;\r\n\tfont-size: 14px;\r\n\tfont-weight: normal;\r\n}\r\n\r\n.document.dashboard > .document-heading > .switch:hover, .document.dashboard.active > .document-heading > .switch:hover {\r\n\ttext-decoration: none;\r\n}\r\n\r\n.document.dashboard.active > .document-body {\r\n\tbackground: #fff;\r\n\tbox-shadow: inset 0px 0px 10px #bbb;\r\n\t-moz-box-shadow: inset 0px 0px 10px #bbb;\r\n\t-webkit-box-shadow: inset 0px 0px 10px #bbb;\r\n}\r\n\r\n.document.dashboard > .document-heading > .draggable {\r\n\tfloat: left;\r\n\tmargin-top: 10px;\r\n\tmargin-left: 25px;\r\n}\r\n\r\n.document.dashboard > .switch {\r\n\tfloat: right;\r\n\tdisplay: block;\r\n\tmargin-top: 5px;\r\n\tfont-size: 14px;\r\n\t/*font-size: 2.0rem;*/\r\n\tfont-weight: bold;\r\n}\r\n\r\n.document-items.dashboard {\r\n\tpadding: 0px 10px 10px 10px;\r\n}\r\n\r\n.document-items.dashboard:first-child {\r\n\tpadding-top: 10px;\r\n}\r\n\r\n.document-items.dashboard > .bo-heading {\r\n\toverflow: hidden;\r\n\tpadding: 3px;\r\n}\r\n\r\n.document-items.dashboard > .bo-heading h5 {\r\n\tfloat: left;\r\n\twidth: 90%;\r\n\tmargin: 0;\r\n\tpadding: 2px 0;\r\n\t\r\n\tfont-size: 16px;\r\n\tfont-size: 1.4rem;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 500;\r\n}\r\n\r\n.document-items.dashboard > .bo-heading h5 > i {\r\n\tmargin-right: 5px;\r\n}\r\n\r\n.document-items.dashboard > .bo-heading .badge {\r\n\tbackground:  var(--main-primary);\r\n\t\r\n\tcolor: #fff;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 12px;\r\n\tfont-size: 1.2rem;\r\n\tfont-weight: 500;\r\n}\r\n\r\n.document-items.dashboard > .bo-heading .switch {\r\n\tfloat: right;\r\n}\r\n\r\n.document-items.dashboard > .bo-heading .switch .pf {\r\n\tcolor: #333;\r\n\tfont-size: 14px;\r\n\t/*font-size: 1.8rem;*/\r\n\tfont-weight: normal;\r\n}\r\n\r\n.document-items.dashboard > .bo-heading .switch:hover {\r\n\ttext-decoration: none !important;\r\n}\r\n\r\n.document-item.dashboards > .bo-body ul, .document-body ul {\r\n\tpadding-left: 20px;\r\n}\r\n\r\n.document-items.dashboard > .bo-body ul li, .document-body ul li {\r\n\tpadding: 5px 0;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 400;\r\n\tlist-style: none;\r\n\tfont-size: 1.2rem;\r\n\r\n\tposition: relative;\r\n    width: 100%;\r\n    clear: both;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.document-items.dashboard > .bo-body ul li a, .document-body ul li a {\r\n\tcolor: #333;\r\n\tpadding-left: 5px;\r\n\t/*\r\n\theight: 15px;\r\n\tdisplay: inline-block;\r\n\twidth: 84%;*/\r\n}\r\n\r\n.document-items.dashboard > .bo-body ul li a.bg-active, .document-body ul li a .bg-active {\r\n\tcolor: white;\r\n}\r\n\r\n.document-items > .bo-body ul li.controlSelected > a {\r\n\tcolor: var(--main-primary) !important;\r\n\tfont-weight: bold;\r\n}\r\n\r\n/* .content-wrap */\r\n.content-wrap {\r\n\twidth: calc(100vw - 250px);\r\n\tmin-height: calc(100vh - 65px);\r\n\tmargin-left: 250px;\r\n\tpadding: 15px 0;\r\n\tpadding-top: calc(70px + 2rem);\r\n\ttransition: width .3s ease, margin-left .3s ease;\r\n\t/*overflow-y: scroll;*/\r\n\t/*overflow-x: hidden;*/\r\n}\r\n\r\n/* When AI panel is open, shrink main content */\r\n.ai-panel-open .content-wrap {\r\n\twidth: calc(100vw - 250px - 380px);\r\n}\r\n\r\n/* AI ChatBot Right Panel */\r\n.dashboard-right-rail {\r\n\tposition: fixed;\r\n\tright: 0;\r\n\ttop: 80px;\r\n\twidth: 380px;\r\n\theight: calc(100vh - 80px);\r\n\tbackground: #fff;\r\n\tborder-left: 1px solid #d5d5d5;\r\n\tz-index: 100;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tbox-shadow: -2px 0 8px rgba(0,0,0,0.08);\r\n}\r\n\r\n.right-panel-header {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\tpadding: 8px 12px;\r\n\tbackground: var(--accent-color, #F89B3C);\r\n\tcolor: #fff;\r\n\tfont-size: 13px;\r\n\tfont-weight: 600;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.right-panel-close {\r\n\tbackground: none;\r\n\tborder: none;\r\n\tcolor: #fff;\r\n\tfont-size: 18px;\r\n\tcursor: pointer;\r\n\tpadding: 0 4px;\r\n\tline-height: 1;\r\n\topacity: 0.8;\r\n}\r\n\r\n.right-panel-close:hover {\r\n\topacity: 1;\r\n}\r\n\r\n#AIChatPanelContent {\r\n\tflex: 1;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\toverflow: hidden;\r\n}\r\n\r\n/* Panel mode overrides for the chat modal */\r\n/* Panel resize handle */\r\n.panel-resize-handle {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\twidth: 4px;\r\n\theight: 100%;\r\n\tcursor: col-resize;\r\n\tz-index: 101;\r\n\tbackground: transparent;\r\n\ttransition: background 0.15s;\r\n}\r\n\r\n.panel-resize-handle:hover,\r\n.panel-resizing .panel-resize-handle {\r\n\tbackground: var(--accent-color, #F89B3C);\r\n}\r\n\r\n/* Prevent text selection while resizing */\r\n.panel-resizing {\r\n\tuser-select: none;\r\n\tcursor: col-resize !important;\r\n}\r\n\r\n#AIChatPanelContent #ai-chat-modal {\r\n\tdisplay: flex !important;\r\n\tflex-direction: column;\r\n\theight: 100%;\r\n\tborder: none;\r\n\tpadding: 0;\r\n}\r\n\r\n#AIChatPanelContent .ai-chat {\r\n\tflex: 1;\r\n\toverflow-y: auto;\r\n\tpadding: 10px;\r\n}\r\n\r\n#AIChatPanelContent .input-group.search-area {\r\n\tflex-shrink: 0;\r\n\tpadding: 8px 10px;\r\n\tborder-top: 1px solid #e0e0e0;\r\n\tbackground: #fafafa;\r\n}\r\n\r\n#AIChatPanelContent #messageCounter {\r\n\tflex-shrink: 0;\r\n\tpadding: 6px 10px;\r\n\tfont-size: 10px;\r\n\ttext-align: center;\r\n\tborder-top: 1px solid #f0f0f0;\r\n\tbackground: #fafafa;\r\n}\r\n\r\n/*\r\n.row .col {\r\n\tpadding-bottom: 2rem;\r\n\tpadding-right: 5rem;\r\n\tpadding-left: 3rem;\r\n}\r\n*/\r\n\r\n.block {\r\n\tmargin-bottom: 30px;\r\n}\r\n\r\n.content-wrap .row {\r\n\tpadding: 5px 30px 4px 30px;\r\n}\r\n\r\n.connection .row{\r\n\tpadding: 5px 0 4px 15px;\r\n}\r\n\r\n.connection .middle-align{\r\n\tmargin-top: 3px;\r\n}\r\n\r\n#dashboard-main-panel .breadcrumb {\r\n\tmargin-bottom: 0px;\r\n\tpadding: 10px 31px;\r\n\tborder-top: 1px solid #d5d5d5;\r\n\tborder-bottom: 1px solid #d5d5d5;\r\n}\r\n\r\n#dashboard-main-panel .page-title h1 {\r\n\tfont-size: 1.9em;\r\n\tmargin-bottom:7px;\r\n}\r\n\r\nul.directory-tree {\r\n  margin: 20px 0px 0px 0px;\r\n  padding: 0 0 0 25px;\r\n  list-style: none;\r\n  line-height: 2em;\r\n  font-family: Arial;\r\n}\r\nul.directory-tree li {\r\n  font-size: 1.1rem;\r\n  position: relative;\r\n  list-style: none;\r\n}\r\n\r\nspan.detFormInstance:hover{\r\n\tcursor: pointer;\r\n\tcolor: #ffffff !important;\r\n\tbackground: var(--main-primary) !important;\r\n\tbackground-image: -moz-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient)) !important;\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom)) !important;\r\n}\r\n\r\n\r\nul.directory-tree li:before {\r\n  position: absolute;\r\n  left: -15px;\r\n  top: 0px;\r\n  content: '';\r\n  display: block;\r\n  border-left: 1px solid #d5d5d5;\r\n  height: 1em;\r\n  border-bottom: 1px solid #d5d5d5;\r\n  width: 10px;\r\n}\r\nul.directory-tree li:after {\r\n  position: absolute;\r\n  left: -15px;\r\n  bottom: -7px;\r\n  content: '';\r\n  display: block;\r\n  border-left: 1px solid #d5d5d5;\r\n  height: 100%;\r\n}\r\nul.directory-tree li.root {\r\n  margin: 0px 0px 0px -20px;\r\n}\r\nul.directory-tree li.root:before {\r\n  display: none;\r\n}\r\nul.directory-tree li.root:after {\r\n  display: none;\r\n}\r\nul.directory-tree li:last-child:after {\r\n  display: none;\r\n}\r\n\r\n/* dropdowns */\r\n\r\n/* Styled select box */\r\n.dropdown {\r\n\tposition: relative;\r\n\tmargin-top: 0px;\r\n}\r\n\r\n.dropdown-toggle {\r\n\twidth: 100%;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.dropdown button {\r\n  background: white;\r\n  width: 100%;\r\n  padding: 5px 0px 5px 8px;\r\n  border: 1px solid #bbb;\r\n  font-family: \"Roboto\", \"sans-serif\";\r\n  font-weight: 400;\r\n  font-size: 14px;\r\n  font-size: 1.4rem;\r\n  color: #333;\r\n  border-radius: 4px;\r\n  -webkit-border-radius: 4px;\r\n  -moz-border-radius: 4px;\r\n  text-align: left;\r\n}\r\n\r\n.dropdown button:hover, .dropdown button:active, .dropdown button:focus, .dropdown button:visited {\r\n\tbackground: #fff;\r\n}\r\n\r\n.open > .dropdown-toggle.btn-default:hover, .open > .dropdown-toggle.btn-default:focus, .btn-default:active.focus, .btn-default.active.focus, .open > .dropdown-toggle.btn-default.focus {\r\n\tbackground: #fff;\r\n\tborder-color: #d5d5d5\r\n}\r\n\r\n.dropdown .caret {\r\n\tfloat: right;\r\n\tmargin: 5px 12px 0 0;\r\n}\r\n\r\n@-moz-document url-prefix() {\r\n\t.dropdown .caret {\r\n\t\tmargin: -12px 12px 0 0;\r\n\t}\r\n}\r\n\r\n.dropdown .dropdown-menu {\r\n\twidth: 100%;\r\n\tmin-width: 140px;\r\n}\r\n\r\n.dropdown .dropdown-menu li {\r\n\tfont-size: 14px;\r\n\tfont-size: 1.4rem;\r\n}\r\n\r\n.dropdown .dropdown-menu a:hover {\r\n\tbackground: #86b823;\r\n\tcolor: #fff;\r\n}\r\n\r\n.dropdown-menu {\r\n\tcursor: pointer;\r\n}\r\n\r\n.dropdown-menu > li > a {\r\n\tpadding: 3px 18px !important;\r\n\tfont-size: 11px;\r\n\r\n}\r\n\r\n.dropdown-menu::before {\r\n  position: absolute;\r\n  top: -7px;\r\n  right: 9px;\r\n  display: inline-block;\r\n  border-right: 7px solid transparent;\r\n  border-bottom: 7px solid #d5d5d5;\r\n  border-left: 7px solid transparent;\r\n  border-top: 0px;\r\n  border-bottom-color: rgba(0, 0, 0, 0.2);\r\n  content: '';\r\n}\r\n\r\n.dropdown-menu::after {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: 10px;\r\n  display: inline-block;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid white;\r\n  border-left: 6px solid transparent;\r\n  border-top: 0px;\r\n  content: '';\r\n}\r\n\r\ndl {\r\n\twidth: 100%;\r\n\tpadding: 0;\r\n    margin: 0;\r\n    overflow: hidden;\r\n\r\n}\r\n\r\ndt {\r\n\tfloat: left;\r\n  \twidth: 50%;\r\n  \tpadding: 0;\r\n  \tmargin: 0 0 5px;\r\n  \tfont-weight: normal;\r\n}\r\n\r\ndd {\r\n\tfloat: left;\r\n  \twidth: 50%;\r\n  \tpadding: 0;\r\n  \tmargin: 0 0 5px;\r\n  \ttext-align: right;\r\n\r\n}\r\n\r\n.panel {\r\n\theight: 180px;\r\n\toverflow-y: auto;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n/* Submenu for drop down */\r\n/*.dropdown-submenu {\r\n    position:relative;\r\n}\r\n.dropdown-submenu>.dropdown-menu {\r\n    top:0;\r\n    left:100%;\r\n    margin-top:-6px;\r\n    margin-left:-1px;\r\n    -webkit-border-radius:0 0px 0px 0px;\r\n    -moz-border-radius:0 0px 0px 0px;\r\n    border-radius:0 0px 0px 0px;\r\n}\r\n.dropdown-submenu:hover>.dropdown-menu {\r\n    display:block;\r\n}\r\n.dropdown-submenu>a:after {\r\n    display:block;\r\n    content:\" \";\r\n    float:right;\r\n    width:0;\r\n    height:0;\r\n    border-color:transparent;\r\n    border-style:solid;\r\n    border-width:5px 0 5px 5px;\r\n    border-left-color:#fff;\r\n    margin-top:5px;\r\n    margin-right:-10px;\r\n}\r\n.dropdown-submenu:hover>a:after {\r\n    border-left-color:#ffffff;\r\n}\r\n.dropdown-submenu.pull-left {\r\n    float:none;\r\n}\r\n.dropdown-submenu.pull-left>.dropdown-menu {\r\n    left:-100%;\r\n    margin-left:10px;\r\n   -webkit-border-radius:0 0px 0px 0px;\r\n    -moz-border-radius:0 0px 0px 0px;\r\n    border-radius:0 0px 0px 0px;\r\n}*/\r\n\r\n.dropdown-submenu>a:after {\r\n\tmargin-top: 4px;\r\n}\r\n\r\n.row-centered {\r\n\ttext-align: center;\r\n}\r\n\r\n.col-centered {\r\n\tfloat: none;\r\n\tmargin: 0 auto;\r\n}\r\n\r\n/* Global elements */\r\n\r\n/***\r\n.help {\r\n\tpadding: 1px 2px;\r\n\t\r\n\tbackground: #fcfcfc;\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%);\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%);\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%);\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 );\r\n\t\r\n\r\n\t\r\n\tborder: 1px solid #d5d5d5;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\t\r\n\tcolor: #799f2c;\r\n}\r\n*/\r\n\r\n.help:hover {\r\n\tcolor:  var(--main-primary);\r\n}\r\n\r\n.style-btn {\r\n\tpadding: 1px 6px;\r\n\t\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\t\r\n\t/*box-shadow: 0px 1px 5px #d5d5d5;\r\n\t-moz-box-shadow: 0px 1px 5px #d5d5d5;\r\n\t-webkit-box-shadow: 0px 1px 5px #d5d5d5;*/\r\n\t\r\n\tborder: 1px solid #d5d5d5;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\t\r\n\tcolor: #333;\r\n}\r\n\r\n/* Buttons */\r\n.btn-group {\r\n\twidth: 100%;\r\n}\r\n#dashboard-main-panel .btn, #dashboard-left-panel .btn {\t\r\n\tpadding: 6px 30px;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-size: 1.3rem;\r\n}\r\n\r\n#dashboard-main-panel .btn-default, #dashboard-left-panel .btn-default {\r\n\t/*margin-right: 15px;*/\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\t\r\n\tborder: 1px solid #d5d5d5;\r\n\t\r\n\tbox-shadow: 0px 2px 5px #d5d5d5;\r\n\t-moz-box-shadow: 0px 2px 5px #d5d5d5;\r\n\t-webkit-box-shadow: 0px 2px 5px #d5d5d5;\r\n\t\r\n\tcolor: #333;\r\n\tfont-weight: 700;\r\n}\r\n\r\n#dashboard-main-panel .btn-default:hover, #dashboard-left-panel .btn-default:hover {\r\n\tborder-color: #d5d5d5;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n\t#dashboard-main-panel .panel-body .info-settings {\r\n\t\twidth: 100%;\r\n\t}\r\n}\r\n\r\n.btn-primary {\r\n\tbackground: var(--main-primary);\r\n\tbackground-image: -moz-linear-gradient(var(--gradient));\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient));\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom));\r\n\t\r\n\tborder: 1px solid var(--main-primary);\r\n\t\r\n\t/*box-shadow: 0px 2px 5px #d5d5d5;\r\n\t-moz-box-shadow: 0px 2px 5px #d5d5d5;\r\n\t-webkit-box-shadow: 0px 2px 5px #d5d5d5;*/\r\n\t\r\n\tcolor: #fff;\r\n\tfont-weight: 700;\r\n}\r\n\r\n.btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {\r\n\tcolor: #fff;\r\n\tbackground: var(--main-primary);\r\n\tbackground-image: -moz-linear-gradient(var(--gradient));\r\n\tbackground-image: -webkit-linear-gradient(var(--gradient));\r\n\tbackground-image: linear-gradient(var(--gradient-ToBottom));\r\n\tborder: 1px solid var(--main-primary);\r\n}\r\n\r\n.action-buttons .dropdown-menu::before {\r\n  position: absolute;\r\n  top: -7px;\r\n  right: 81px;\r\n  display: inline-block;\r\n  border-right: 7px solid transparent;\r\n  border-bottom: 7px solid #d5d5d5;\r\n  border-left: 7px solid transparent;\r\n  border-top: 0px;\r\n  border-bottom-color: rgba(0, 0, 0, 0.2);\r\n  content: '';\r\n}\r\n\r\n.action-buttons .dropdown-menu::after {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: 82px !important;\r\n  display: inline-block;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid #ffffff;\r\n  border-left: 6px solid transparent;\r\n  border-top: 0px;\r\n  content: '';\r\n}\r\n\r\n.action-buttons .btn-primary {\r\n\tmargin-right: 0px;\r\n}\r\n\r\n/* Search box */\r\n.search-box input[type=\"text\"] {\r\n\twidth: 99%;\r\n\tpadding: 5px 5px 5px 8px;\r\n\tborder-radius: 4px;\r\n\t-moz-border-radius: 4px;\r\n\t-webkit-border-radius: 4px;\r\n\t\r\n\tborder: 1px solid #d5d5d5;\r\n\t\r\n\tbox-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\t-webkit-box-shadow: none;\r\n\t\r\n\tcolor: #949494;\r\n\tfont-family: \"Roboto\", \"sans-serif\";\r\n\tfont-weight: 400;\r\n\tfont-size: 1.2rem;\r\n\theight: 25px;\r\n\tfont-size: 11px;\r\n}\r\n\r\n.search-box input[type=\"text\"]:focus {\r\n\tcolor: #333333;\r\n\toutline: none;\r\n\tborder-color: #bbb;\r\n\tbox-shadow: none;\r\n\t-moz-box-shadow: none;\r\n\t-webkit-box-shadow: none;\r\n}\r\n\r\n/* Styled select box */\r\n\r\n\r\n.dropdown-toggle {\r\n\twidth: 100%;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.dashTbl-icon{\r\n\twidth:  20px !important;\r\n\theight:  20px !important;\r\n\tfont-size:  12px !important;\r\n\tbackground: #ababab;\r\n\tpadding:  2px 2px !important;\r\n\tcolor: #ffffff;\r\n\tborder-right-color:  #a8a8a8;\r\n\tborder-bottom-color:  #a8a8a8;\r\n\tmargin-top: 2px;\r\n}\r\n\r\n.dashTbl-icon:disabled{\r\n\tcursor: default;\r\n}\r\n\r\n/* Draggable */\r\n.draggable:hover {\r\n\tcursor: move;\r\n}\r\n\r\n.progress-bar-success {\r\n\tbackground: #8eb934; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top, #8eb934 0%, #799f2d 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top, #8eb934 0%,#799f2d 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom, #8eb934 0%,#799f2d 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#8eb934', endColorstr='#799f2d',GradientType=0 );\r\n}\r\n\r\n.progress-bar-warning {\r\n\tbackground: #f29a31; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top, #f29a31 0%, #c77e28 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top, #f29a31 0%,#c77e28 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom, #f29a31 0%,#c77e28 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f29a31', endColorstr='#c77e28',GradientType=0 );\r\n}\r\n\r\n.progress-bar-danger {\r\n\tbackground: #e82e2d; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top, #e82e2d 0%, #c42726 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top, #e82e2d 0%,#c42726 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom, #e82e2d 0%,#c42726 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e82e2d', endColorstr='#c42726',GradientType=0 );\r\n}\r\n\r\n/*.nav-tabs > li:first-child.active > a {\r\n\tborder-right: 1px solid #d5d5d5;\r\n}*/\r\n\r\n.nopadding {\r\n   padding: 0 !important;\r\n   margin: 0 !important;\r\n}\r\n\r\n.nopadding-l {\r\n\tpadding-left: 0px !important;\r\n}\r\n\r\n.nopadding-r {\r\n\tpadding-right: 0px !important;\r\n\tmargin-right: 0px !important;\r\n}\r\n\r\n\r\n.strong {\r\n\tfont-weight: bold !important;\r\n}\r\n\r\n/*.icon-gradient:before {\r\n\tbackground: -webkit-gradient(linear, left top, left bottom, from(#9e9e9e), to(#777));\r\n\t    -webkit-background-clip: text;\r\n\t    -webkit-text-fill-color: transparent;\r\n\t\ttext-shadow: 0px 1px 2px rgba(0,0,0,0.2);\r\n}*/\r\n\r\n/* Attention level tooltips */\r\n.attn-tooltip {outline:none; }\r\n.attn-tooltip strong {line-height:10px;}\r\n.attn-tooltip:hover {text-decoration:none;} \r\n.attn-tooltip .attn-tooltip-container {\r\n    z-index:10;\r\n    display:none; \r\n    padding:5px 15px;\r\n    margin-top:-30px; \r\n    margin-left:0px;\r\n    /*width:300px; */\r\n    line-height:16px;\r\n    -webkit-animation: fadeout 0.5s; /* Safari, Chrome and Opera > 12.1 */\r\n       -moz-animation: fadeout 0.5s; /* Firefox < 16 */\r\n        -ms-animation: fadeout 0.5s; /* Internet Explorer */\r\n         -o-animation: fadeout 0.5s; /* Opera < 12.1 */\r\n            animation: fadeout 0.5s;\r\n}\r\n@keyframes fadeout {\r\n    from { opacity: 1; }\r\n    to   { opacity: 0; }\r\n}\r\n\r\n/* Firefox < 16 */\r\n@-moz-keyframes fadeout {\r\n    from { opacity: 1; }\r\n    to   { opacity: 0; }\r\n}\r\n\r\n/* Safari, Chrome and Opera > 12.1 */\r\n@-webkit-keyframes fadeout {\r\n    from { opacity: 1; }\r\n    to   { opacity: 0; }\r\n}\r\n\r\n/* Internet Explorer */\r\n@-ms-keyframes fadeout {\r\n    from { opacity: 1; }\r\n    to   { opacity: 0; }\r\n}\r\n\r\n/* Opera < 12.1 */\r\n@-o-keyframes fadeout {\r\n    from { opacity: 1; }\r\n    to   { opacity: 0; }\r\n}\r\n\r\n.attn-tooltip:hover .attn-tooltip-container{\r\n    display:inline; \r\n    position:absolute; \r\n    color:#333;\r\n    border:1px solid rgba(213,213,213, 0.8); \r\n    background: rgba(255,255,255, 0.8);\r\n    text-align: left;\r\n\r\n    -webkit-animation: fadein 0.5s; /* Safari, Chrome and Opera > 12.1 */\r\n       -moz-animation: fadein 0.5s; /* Firefox < 16 */\r\n        -ms-animation: fadein 0.5s; /* Internet Explorer */\r\n         -o-animation: fadein 0.5s; /* Opera < 12.1 */\r\n            animation: fadein 0.5s;\r\n}\r\n\r\n@keyframes fadein {\r\n    from { opacity: 0; }\r\n    to   { opacity: 1; }\r\n}\r\n\r\n/* Firefox < 16 */\r\n@-moz-keyframes fadein {\r\n    from { opacity: 0; }\r\n    to   { opacity: 1; }\r\n}\r\n\r\n/* Safari, Chrome and Opera > 12.1 */\r\n@-webkit-keyframes fadein {\r\n    from { opacity: 0; }\r\n    to   { opacity: 1; }\r\n}\r\n\r\n/* Internet Explorer */\r\n@-ms-keyframes fadein {\r\n    from { opacity: 0; }\r\n    to   { opacity: 1; }\r\n}\r\n\r\n/* Opera < 12.1 */\r\n@-o-keyframes fadein {\r\n    from { opacity: 0; }\r\n    to   { opacity: 1; }\r\n}\r\n\r\n\r\n    \r\n/*CSS3 extras*/\r\n.attn-tooltip .attn-tooltip-container\r\n{\r\n    border-radius:4px;\r\n    /*box-shadow: 5px 5px 8px #CCC;*/\r\n}\r\n\r\n\r\n/* Alerts */\r\n\r\n.alert-container {\r\n\tposition: absolute;\r\n\twidth: 98%;\r\n\ttop: 10px;\r\n\tleft: 0px;\r\n\tz-index: 100;\r\n}\r\n\r\n.alert {\r\n\tdisplay: table;\r\n\t\r\n\tmargin: 15px auto;\r\n\tpadding: 0;\r\n\ttop: 10px;\r\n\tmin-width: 20%;\r\n\tmax-width: 30%;\r\n\t\r\n\tbackground: #fcfcfc; /* Old browsers */\r\n\tbackground: -moz-linear-gradient(top,  #fcfcfc 0%, #eeeeee 100%); /* FF3.6-15 */\r\n\tbackground: -webkit-linear-gradient(top,  #fcfcfc 0%,#eeeeee 100%); /* Chrome10-25,Safari5.1-6 */\r\n\tbackground: linear-gradient(to bottom,  #fcfcfc 0%,#eeeeee 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\r\n\tfilter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#fcfcfc', endColorstr='#eeeeee',GradientType=0 ); /* IE6-9 */\r\n\t\r\n\tborder: #d5d5d5;\r\n\t\r\n}\r\n\r\n.alert-icon {\r\n\tdisplay: table-cell;\r\n\twidth: 57px;\r\n\theight: 100%;\r\n\tmargin-right: 20px;\r\n\tpadding: 10px;\r\n\tfont-size: 3.0rem;\r\n\tfont-size: 30px;\r\n\ttext-align: center;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.alert-content {\r\n\tdisplay: table-cell;\r\n\tpadding: 10px;\r\n\tfont-size: 1.4rem;\r\n\tfont-size: 14px;\r\n\tvertical-align: middle;\r\n\tmin-width:600px;\r\n}\r\n\r\n.alert-close {\r\n\tdisplay: table-cell;\r\n\tvertical-align: top;\r\n}\r\n\r\n.alert-dismissable .close, .alert-dismissible .close {\r\n\ttop: 2px;\r\n\tright: 10px;\r\n}\r\n\r\n\r\n.alert-warning {\r\n\twidth: 30%;\r\n\tborder: 1px solid #938f23 !important;\r\n\tbox-shadow: 0px 0px 20px rgba(143,141,90, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(143,141,90, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-warning .alert-icon {\r\n\tbackground: rgba(147,143,35, 0.10);\r\n\tcolor: #807d2c;\r\n}\r\n\r\n.alert-danger {\r\n\twidth: 30%;\r\n\tborder: 1px solid #a73837 !important;\r\n\tbox-shadow: 0px 0px 20px rgba(167,122,123, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(167,122,123, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-danger .alert-icon {\r\n\tbackground: rgba(231,67,67,0.10);\r\n\tcolor: #7d2a2a;\r\n}\r\n\r\n.alert-success {\r\n\twidth: 30%;\r\n\tborder: 1px solid #5e8c26 !important;\r\n\tbox-shadow: 0px 0px 20px rgba(121,139,99, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(121,139,99, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-success .alert-icon {\r\n\tbackground: rgba(94,140,38,0.10);\r\n\tcolor: #497c30;\r\n}\r\n\r\n.alert-info {\r\n\twidth: 30%;\r\n\tborder: 1px solid #2d84a4;\r\n\tbox-shadow: 0px 0px 20px rgba(116,149,161, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(116,149,161, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-info .alert-icon {\r\n\tbackground: rgba(45,132,164, 0.10);\r\n\tcolor: #246a84;\r\n}\r\n\r\n.alert-view {\r\n\tborder: 1px solid #cc7929;\r\n\tbox-shadow: 0px 0px 20px rgba(136,88,43, 0.75);\r\n\t-moz-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);\r\n\t-webkit-box-shadow: 0px 0px 20px rgba(136,88,43, 0.75);\r\n\tcolor: #333;\r\n}\r\n\r\n.alert-view .alert-icon {\r\n\tbackground: rgba(204,121,41, 0.10);\r\n\tcolor: #b76d25;\r\n}\r\n\r\n/*Modal*/\r\n.modal-header {\r\n\ttext-align: left;\r\n\tborder: 0px;\r\n}\r\n\r\n.modal-header h4 {\r\n\tpadding-bottom: 8px;\r\n\tfont-size: 2.4rem;\r\n\tfont-size: 24px;\r\n\tborder-bottom: 1px solid #e5e5e5;\r\n}\r\n\r\n.modal-body {\r\n\ttext-align: left;\r\n}\r\n\r\n.modal-footer {\r\n\tborder: 0px;\r\n}\r\n\r\n.modal-footer .btn {\r\n\twidth: auto;\r\n}\r\n\r\n/* Styles for row click selection on jqgrid */\r\n.ui-jqgrid-btable .ui-state-highlight { background: #dff0d8 !important; }\r\n.ui-jqgrid .ui-state-highlight { background: #dff0d8 !important; }\r\n\r\n\r\n/*PF-5427 style to show properly the asc/desc sort icon in jqgrids */\r\n.ui-jqgrid .s-ico > .ui-icon-asc.ui-icon.ui-sort-ltr, .ui-jqgrid .s-ico > .ui-icon-desc.ui-icon.ui-sort-ltr {\r\n     margin-left: 0;\r\n}\r\n\r\n.ui-jqgrid .s-ico > .ui-icon-asc.ui-icon {\r\n    top: -3px;\r\n}\r\n\r\n.ui-jqgrid .s-ico > .ui-icon-desc.ui-icon {\r\n    top: -10px;\r\n}\r\n\r\n#dashboard-main-panel .pf-btn-small{\r\n\tpadding:5px 5px 5px 5px\r\n}\r\n\r\nbody{\r\n\toverflow: scroll;\r\n}\r\n\r\n#file-upload-button{\r\n\tpadding: 0;\r\n}\r\n\r\n#file-upload-label{\r\n\theight: 24px;\r\n\twidth: 90px;\r\n\tpadding: 5px 0;\r\n\tmargin: 0;\r\n\tfont-weight: bold;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.file-upload-label{\r\n\theight: 24px;\r\n\twidth: 90px;\r\n\tpadding: 5px 0;\r\n\tmargin: 0;\r\n\tfont-weight: bold;\r\n\tfont-size: 12px;\r\n}\r\n\r\n#dashboard-main-panel textarea[name=\"IPList\"]{\r\n\tmin-height: 0 !important;\r\n}\r\n\r\n#dashboard-main-panel #recentEdits ul li,\r\n#dashboard-main-panel #recentEditsEFD ul li,\r\n#dashboard-main-panel #favoriteForms  ul li {\r\n\tfont-size: 1.2rem;\r\n\tpadding: 0.3rem 0;\r\n}\r\n\r\n#dashboard-main-panel #actionDetails h4, #dashboard-main-panel #actionDetails .block {\r\n\tmargin-bottom: 0 !important;\r\n}\r\n\r\n#dashboard-main-panel #actionDetails h2, #dashboard-main-panel #actionGeneral h2 {\r\n\tmargin-top: 0 !important;\r\n}\r\n\r\n#dashboard-main-panel #actionDetails .row, \r\n#dashboard-main-panel #actionGeneral .row,\r\n#dashboard-main-panel #connectionGeneral .row {\r\n\tpadding-bottom: 0 !important;\r\n}\r\n\r\n#dashboard-main-panel #actionDetails .ui-jqgrid-bdiv {\r\n\tmax-height: 165px !important;\r\n}\r\n\r\n.statusWarning{\r\n\tcolor:red;\r\n}\r\n\r\n.select-list {\r\n\tpadding: 5px;\r\n}\r\n\r\n.select-list li {\r\n\tpadding: 0.15em 0 0.5em 1.9em;\r\n\tmargin-bottom: 0.2em;\r\n\ttext-indent: 0.4em;\r\n\t/*font-weight:bold;*/\r\n\tlist-style: none;\r\n\tbackground-repeat: no-repeat;\r\n\tmin-height:25px;\r\n}\r\n.select-list li[data-type=\"group\"]{\r\n\tbackground-image:url('../../images/common/icons/GROUP-24.png');\r\n}\r\n.select-list li[data-type=\"user\"]{\r\n\tbackground-image:url('../../images/common/icons/PERSON-24.png');\r\n}\r\n.select-list li[data-type=\"position\"]{\r\n\tbackground-image:url('../../images/common/icons/ROLE-24.png');\r\n}\r\n.select-list li[data-type=\"everyone\"]{\r\n\tbackground-image:url('../../images/common/icons/EVERYBODY-24.png');\r\n}\r\n.select-list li[data-type=\"world\"]{\r\n\tbackground-image:url('../../images/common/icons/EVERYBODY-24.png');\r\n}\r\n\r\n.col-sm-1 {\r\n    height: 30px;    \r\n}\r\n\r\n.bottom-align{\r\n\tposition: absolute; left: 0; bottom: 0\r\n}\r\n\r\n.li-disabled{\r\n\tpointer-events:none;\r\n    opacity:0.6;\r\n}\r\n\r\n.row-hidden{\r\n\topacity: .3 !important;\r\n}\r\n\r\n.attention-level-left-padding{\r\n\tpadding-left: 40px;\r\n}\r\n\r\n.perm-detail-panel {\r\n\tborder: 1px solid #d8d8d8;\r\n\tmargin-left: 1em;\r\n\tmargin-right: 5em;\r\n}\r\n\r\n.perm-name {\r\n\tmargin-left: -1em;\r\n}\r\n\r\n.dim-text {\r\n\tcolor: #aaaaaa;\r\n}\r\n#pf-upgrade-urgent > a {\r\n\tcolor:red !important;\r\n}\r\n\r\n#pf-upgrade-normal > a {\r\n\tcolor:gray !important;\r\n}\r\n\r\n.ui-autocomplete-loading {\r\n    background: white url(\"../../images/loadingIndicator.gif\") right center no-repeat;\r\n  }\r\n\r\n.ui-autocomplete {\r\n    max-height: 500px;\r\n    overflow-y: auto;\r\n    /* prevent horizontal scrollbar */\r\n\toverflow-x: hidden;\r\n\tfont-size: 11px;\r\n}\r\n  /* IE 6 doesn't support max-height\r\n   * we use height instead, but this forces the menu to always be this tall\r\n   */\r\n* html .ui-autocomplete {\r\n    height: 500px;\r\n}\r\n.disable-link{\r\n\tpointer-events: none\r\n}\r\n\r\n.dashboard-favorited-item {\r\n\tbackground: linear-gradient(var(--gradient-ToBottom));\r\n}\r\n\r\n/*dialogs*/\r\n.ui-dialog {\r\n\tfont-size: 12px;\r\n\tfont-family: 'Poppins';\r\n}\r\n\r\n#dialog, #dialog-greeting, #report-form-dialog, #deleteModal, #confirmDeleteModal {\r\n\tfont-size: 12px;\r\n}\r\n\r\n#dialog h4 {\r\n\tfont-size: 1.4rem;\r\n}\r\n\r\n.ui-dialog-buttonset button{\r\n\tfont-family: 'Poppins';\r\n}\r\n\r\n.confirm-delete-top-section {\r\n\tpadding: 0 0 0 15px; width: 100%; height: auto !important;\r\n}\r\n\r\n.confirm-delete-bottom-section {\r\n\tpadding: 0 0 10px 15px; width: 100%; height: auto !important;\r\n}\r\n\r\n.map-versions-bottom-section {\r\n\tpadding: 0 0 10px 15px; width: 100%;\r\n}\r\n\r\n.map-versions-bottom-section .ui-jqgrid-view{\r\n\tpadding: 1px !important;\r\n}\r\n\r\n.form-link-modal {\r\n\tpadding: 0 0 0 15px; width: 100%;\r\n}\r\n\r\n/*Dashboard permissions*/\r\n@media screen and (max-width: 1200px) {\r\n\t.permissions-list {\r\n\t\theight: 100px; \r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n}\r\n/***********************/\r\n\r\n/*For button choose in color picker*/\r\n.sp-container button {\r\n\tfont-size: 11px !important;\r\n}\r\n\r\n\r\n/*Scroll bar change to auto for some components*/\r\n.show-scroll-bar-y {\r\n\toverflow-y: auto;\r\n}\r\n\r\n.pre-scrollable {\r\n\toverflow-y: auto;\r\n}\r\n\r\nform.migrate-form hr {\r\n\tmargin: 0;\r\n}\r\nform.migrate-form span.header {\r\n\tfont-weight: bold;\r\n}\r\nform.migrate-form span.separator {\r\n\tmargin-right: 10px;\r\n}\r\nform.migrate-form input[type=\"radio\"] {\r\n\tmargin-top: 1px;\r\n\tvertical-align: middle;\r\n}\r\n\r\nform.migrate-form input[type=\"checkbox\"] {\r\n\tmargin-top: -1.5px;\r\n    vertical-align: middle;\r\n}\r\n/*Refresh connections*/\r\n\r\n.refresh-actions {\r\n\tpadding-top: 2px;\r\n\tpadding-left: 8px;\r\n\ttext-align: end;\r\n}\r\n\r\n.dashboard-left-rail-scroll ul li a {\r\n    display: inline;\r\n}\r\n\r\n\r\n/*Settings button*/\r\n.toolbar-button-container {\r\n\t-webkit-user-select: none;\r\n\t-khtml-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-o-user-select: none;\r\n\tuser-select: none;\r\n\twidth: 55px !important; \r\n\theight: 55px !important;  \t\r\n}\r\n\r\n.toolbar-button-container div {  \r\n\twidth: 55px !important; \r\n\theight: 55px !important;  \r\n}\r\n\r\n.toolbar-button {\r\n\tdisplay: inline-block;\r\n    color: #444;\r\n    border: 1px solid #CCC !important;\r\n    border-radius: 5px;\r\n    background: linear-gradient(to bottom, #fcfcfc 0%,#eeeeee 100%); \r\n    cursor: pointer;\r\n    vertical-align: middle;\r\n    text-align: center;\r\n    height: 50px !important;\r\n\twidth: 53px !important;\r\n\tmargin: 0 auto 2px 9px !important;\r\n}\r\n\r\n.toolbar-button i {\r\n\tmargin-top: 4px !important;\r\n\tcolor:  var(--main-primary) !important;\r\n}\r\n\r\n.toolbar-button p {\r\n\tmargin-top: -6px !important;\r\n\tcolor:  var(--main-primary) !important;\r\n}\r\n\t\r\n.toolbar-button p.assets-top {\r\n\tmargin-top: 12px !important;\t \r\n}\r\n\r\n\r\n/*Messages shown when mobile*/\r\n#dashboard-main-panel .message-container-mobile {\r\n\tdisplay: inline-flex;\r\n}\r\n\r\n#dashboard-main-panel .message-container-mobile > label {\r\n\tfont-weight: bold; line-height: normal; text-align: justify; font-size: 13px;\r\n}\r\n\r\n.format-table-properties .ui-jqgrid-bdiv {\r\n\tmax-height: 135px !important;\r\n\toverflow-x: hidden;\r\n\toverflow-y: auto !important;\r\n}\r\n\r\n.format-table-sources .ui-jqgrid-bdiv {\r\n\toverflow-x: hidden;\r\n\toverflow-y: auto !important;\r\n}\r\n\r\n.format-table-overflow-shown { \r\n\toverflow-x: auto !important; \r\n}\r\n\r\n/*PF-3986*/\r\n\r\n.btn-disabled {\r\n\topacity: 0.5;\r\n  \tbackground: #CCC;\r\n}\r\n\r\n.right-menu {\r\n\tposition:relative;\r\n\tfloat:right;\r\n}\r\n.right-caret {\r\n\r\n\tborder-bottom: 4px solid transparent;\r\n\tborder-top: 4px solid transparent;\r\n\tborder-left: 4px solid #000000;\r\n\tdisplay: inline-block;\r\n\theight: 0;\r\n\topacity: 1;\r\n\tvertical-align: top;\r\n\twidth: 0;\r\n\r\n}\r\n.right\r\n{\r\n\tfloat:right;\r\n}\r\n\r\n.dropdown-submenu {\r\n\tposition:relative;\r\n}\r\n.dropdown-submenu>.dropdown-menu {\r\n\ttop:0;\r\n\tleft:100%;\r\n\tmargin-top:-6px;\r\n\tmargin-left:-1px;\r\n\t-webkit-border-radius:0 6px 6px 6px;\r\n\t-moz-border-radius:0 6px 6px 6px;\r\n\tborder-radius:0 6px 6px 6px;\r\n}\r\n.dropdown-submenu:hover>.dropdown-menu {\r\n\tdisplay:block;\r\n}\r\n.dropdown-submenu>a:after {\r\n\tdisplay:block;\r\n\tcontent:\" \";\r\n\tfloat:right;\r\n\twidth:0;\r\n\theight:0;\r\n\tborder-color:transparent;\r\n\tborder-style:solid;\r\n\tborder-width:5px 0 5px 5px;\r\n\tborder-left-color:#cccccc;\r\n\tmargin-top:5px;\r\n\tmargin-right:-10px;\r\n}\r\n.dropdown-submenu:hover>a:after {\r\n\tborder-left-color:#ffffff;\r\n}\r\n.dropdown-submenu.pull-left {\r\n\tfloat:none;\r\n}\r\n.dropdown-submenu.pull-left>.dropdown-menu {\r\n\tleft:-100%;\r\n\tmargin-left:10px;\r\n\t-webkit-border-radius:6px 0 6px 6px;\r\n\t-moz-border-radius:6px 0 6px 6px;\r\n\tborder-radius:6px 0 6px 6px;\r\n}\r\n\r\n.jqGrid-alt-row{\r\n\tbackground-color: #DDDDDC;\r\n}\r\n\r\n.item-link{\r\n\tcursor: pointer;\r\n}\r\n\r\n#accountDetails input[type=checkbox], #accountDetails input[type=radio] {\r\n\tvertical-align: middle;\r\n\tposition: relative;\r\n\tbottom: 1px;\r\n\tmargin: 0 5px 0 0;\r\n}\r\n  \r\n#accountDetails input[type=radio] {\r\n\tbottom: 2px;\r\n}\r\n\r\n\r\n.col-form-label{\r\n\tpadding-top: 4px;\r\n}\r\n\r\n.instances-filter{\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n.ui-dialog-buttonpane{\r\n\tborder: none;\r\n}\r\n\r\n.button-as-dropdown{\r\n\tpadding: 5px 8px!important;\r\n}\r\n\r\n.button-as-dropdown .caret{\r\n\tmargin: 8px 0 0 0!important;\r\n}\r\n\r\n.helpSection{\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.inputWithButton{\r\n\twidth: 80%!important;\r\n\tfloat:left!important;\r\n}\r\n\r\n@media (min-width: 1400px) {\r\n\t.inputWithButton{\r\n\t\twidth: 88%!important;\r\n\t}\r\n}\r\n\r\n.buttonWithInput{\r\n\tfloat: right!important;\r\n}\r\n\r\n.actionButtons{\r\n\tmargin-top:10px;\r\n}\r\n\r\ninput[type=checkbox], input[type=radio]{\r\n\tvertical-align: -2px;\r\n}\r\n\r\n.quick-help-view{\r\n\tmargin-right: -15px;\r\n\tposition: absolute;\r\n    z-index: 9999999;\r\n}\r\n\r\n.quick-help .header{\r\n\theight: 30px;\r\n\tmargin-top: 5px;\r\n}\r\n\r\n.quick-help .tag{\r\n\twidth: 30px;\r\n    background-color: var(--accent-color);\r\n    height: 30px;\r\n\tcolor: #ffffff;\r\n\tcursor: pointer;\r\n\tpadding-left: 12px;\r\n    font-size: 23px;  \r\n}\r\n\r\n.quick-help .opened-tag{\r\n\twidth: 0;\r\n}\r\n\r\n.quick-help .opened-tag .text{\r\n\tfont-size: 15px;\r\n    background-color: #fff;\r\n    height: 30px;\r\n    border-top: solid 1px #c5c5c5;\r\n    margin-left: 30px;\r\n    font-weight: bold;\r\n\tpadding: 5px;\r\n\tfont-family: Poppins;\r\n}\r\n\r\n.quick-help .opened-tag .tag{\r\n\tpadding-left: 4px;\r\n\tfloat: left;\r\n}\r\n\r\n.quick-help .opened-tag img{\r\n\twidth: 22px;\r\n    margin-top: -4px;\r\n}\r\n\r\n.quick-help .closed-tag .tag{\r\n\tborder-top-left-radius: 5px;\r\n    border-bottom-left-radius: 5px;\r\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.quick-help .opened-help{\r\n\tfloat:left;\r\n\toverflow: hidden;\r\n\tbackground: #fff;\r\n    box-shadow: 4px 6px 4px 0px rgba(0, 0, 0, 0.25);\r\n\twidth: 0px;\t\r\n}\r\n\r\n.quick-help .box-inner{\r\n\tpadding: 10px;    \r\n\tborder: 1px solid #c5c5c5;\r\n\tdisplay: none;\r\n\tfont-size: 14px;\r\n\tfont-family: Poppins;\r\n}\r\n\r\n.quick-help ul{\r\n\tlist-style: none;\r\n\tpadding: 0;\r\n}\r\n\r\n.quick-help li{\r\n\tpadding: 2.5px 5px;\r\n}\r\n\r\n.quick-help li:hover{\r\n\tbackground-color: #F1F1F1;\t\r\n\tcursor: pointer;\r\n}\r\n\r\n.quick-help hr{\r\n\tmargin: 10px 0;\r\n}\r\n\r\n.dashboard-modal-dialog{\r\n\tborder-radius: 10px;\r\n    box-shadow: 1px 1px #C5C5C5;\r\n\tfont-family: Poppins;\r\n}\r\n\r\n.dashboard-modal-dialog svg{\r\n\tfill: var(--main-primary);\r\n}\r\n\r\n.dashboard-modal-dialog a{\r\n\tfont-family: Poppins!important;\r\n    font-weight: 600!important;\r\n}\r\n\r\n.dashboard-modal-dialog-titlebar{\r\n\tborder-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    height: 40px;\r\n    background: none!important;\r\n    background-color: var(--accent-green)!important;\r\n    margin: 1px;\r\n\ttext-align: center;\r\n    padding: 8px!important;\r\n}\r\n\r\n.dashboard-modal-dialog-titlebar-hidden{\r\n\tdisplay: none;\r\n}\r\n\r\n.dashboard-modal-title{\r\n\tfloat: none!important;\r\n\tmargin: 0!important;\r\n\tfont-size: 18px;\r\n}\r\n\r\n.dashboard-modal-dialog-titlebar-notification{\r\n\tborder-top-left-radius: 10px;\r\n    border-top-right-radius: 10px;\r\n    height: 35px;\r\n    background: none!important;\r\n    background-color: var(--accent-green)!important;\r\n    margin: 1px;\r\n\ttext-align: left;\r\n    padding: 8px!important;\r\n}\r\n\r\n.dashboard-modal-title-notification{\r\n\tfloat: none!important;\r\n\tmargin: 0!important;\r\n\tfont-size: 14px;\r\n}\r\n\r\n.dashboard-modal-content{\r\n\tmargin: 20px 0;\r\n}\r\n\r\n.dashboard-modal-button{\r\n\tbackground-color: var(--accent-color);\r\n    color: #fff;\r\n    border: #fff;\r\n    height: 25px;\r\n    width: 90px;\r\n    box-shadow: 2px 2px #C5C5C5;\r\n    border-radius: 5px;\r\n}\r\n\r\n.divider{\r\n\theight: 2px;\r\n\twidth: 100%;\r\n\tbackground-color: #F5F5F5;\r\n}\r\n\r\n.workspace{\r\n\tfont-family: Poppins;\r\n}\r\n\r\n.dashboard-card{\r\n\twidth: 20vw;\r\n\tmargin-bottom: 5px;\r\n\tcursor: pointer;\r\n}\r\n\r\n.ui-dialog .dashboard-card{\r\n\twidth: 15vw;\r\n}\r\n\r\n.workspace .title{\t\r\n    font-size: 2vw;\r\n    margin: 20px 0;\r\n}\r\n\r\n.workspace .text{\r\n\tfont-size: 1.2vw;\r\n}\r\n\r\n.trial-status{\r\n\tborder: #C5C5C5 1px solid;\r\n    margin: 10px 10px;\r\n\tpadding: 0 15px;\r\n\tfont-family: Poppins;\r\n\tborder-radius: 10px;\r\n\tbox-shadow: 3px 3px 5px #C5c5c5;\r\n\tfont-size: 12px;\r\n}\r\n\r\n.trial-status .title{\r\n\tbackground-color:var(--accent-color);\r\n    color: #fff;\r\n    border-top-right-radius: 10px;\r\n    border-top-left-radius: 10px;\r\n    padding: 10px 15px;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n\tletter-spacing: .2px;\r\n}\r\n\r\n.trial-status .content{\r\n\tmargin: 15px;\r\n}\r\n\r\n.trial-status .button{\r\n\tmargin-top: 15px;\r\n}\r\n\r\n.trial-status button, \r\n.workspace button{\r\n\tbackground-color: var(--accent-color);\r\n    color: #fff;\r\n    border: none;\r\n    padding: 10px 12px;\r\n    border-radius: 5px;\r\n    font-weight: 500;\r\n    font-size: 13px;\r\n    box-shadow: 3px 3px 5px #C5c5c5;\r\n\tletter-spacing: .2px;\r\n}\r\n\r\n.dashboard-accent-button{\r\n\tfont-weight: 600;\r\n\tmin-width: 100px;\r\n}\r\n\r\n.modal-container{\r\n\tfont-family: Poppins;\r\n}\r\n\r\n.modal-button{\r\n\tcolor: #fff;\r\n    border: none;\r\n    padding: 10px 12px;\r\n    border-radius: 5px;\r\n    font-weight: 500;\r\n    font-size: 13px;\r\n    box-shadow: 3px 3px 5px #C5c5c5;\r\n\tletter-spacing: .2px;\r\n\tfont-weight: 600;\r\n\tmin-width: 100px;\r\n\tcursor: pointer;\r\n\r\n\ttransition: background 0.3s ease-in-out;\r\n}\r\n\r\n.modal-accent-button{\r\n\tbackground: linear-gradient(to bottom, var(--accent-color) 0%, var(--gradient-accent-color) 100%);\r\n}\r\n\r\n.modal-accent-button:hover {\r\n    background: linear-gradient(to bottom, var(--gradient-accent-color) 0%, var(--accent-color) 100%);\r\n}\r\n\r\n.modal-cancel-button{\r\n\tbackground: linear-gradient(to bottom, #fcfcfc 0%, #eeeeee 100%);\r\n\tborder: 1px solid #d5d5d5;\r\n\tcolor: #000000;\r\n}\r\n\r\n.modal-cancel-button:hover {\r\n    background: linear-gradient(to bottom, #eeeeee 0%, #fcfcfc 100%);\r\n\tfont-weight: bold;\r\n}\r\n\r\n.workspace .row{\r\n\tpadding: 5px 22px;\r\n}\r\n\r\n.trial-status .indicators{\r\n    margin-top: 5px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.trial-status .indicator{\r\n\theight: 8px;\r\n    border-radius: 10px;\r\n\tfloat: left;\r\n    margin-right: 5px;\r\n}\r\n\r\n.trial-status .used{\r\n\tbackground:var(--main-primary);\r\n}\r\n\r\n.trial-status .notUsed{\r\n\tbackground: #D9D9D9;\r\n}\r\n\r\n.trial-status .remaining-border{\r\n\tborder-radius: 15px;\r\n    background-color: var(--main-primary);\r\n    width: 177px;\r\n    height: 8px;\r\n    padding: 2px 3px;\r\n}\r\n\r\n.trial-status .remaining-fill{\r\n\tborder-radius: 10px;\r\n    height: 4px;\r\n    background-color: #fff;\r\n}\r\n\r\n.workspace-table{\r\n\tfont-size: 13px;\r\n}\r\n\r\n.workspace-table .row{\r\n\tpadding: 0 15px;\r\n}\r\n\r\n.workspace-table .app-name{\r\n\tfont-weight: 600;\r\n    font-size: 13px;\r\n}\r\n\r\n.workspace-table .app-lastUpdate{\r\n\tfont-size: 11px;\r\n}\r\n\r\n.workspace-table a{\r\n\tcolor:var(--main-primary);\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.workspace-table i{\r\n\tfont-size: 18px;\r\n\tcursor: pointer;\r\n\tmargin: 0px 10px;\r\n}\r\n\r\n.workspace-table i.disabled{\r\n\tcursor: default;\r\n\tcolor: #ccc;\r\n\tpointer-events: none;\r\n}\r\n\r\n.workspace-table i.disabled:hover{\r\n\tcursor: default;\r\n\tcolor: #ccc;\r\n}\r\n\r\n.workspace-table i:hover{\r\n\tcolor: var(--accent-color);\r\n}\r\n\r\n.table-context-menu{\r\n\twidth: 150px;\r\n    position: absolute;\r\n    display: none;\r\n\tborder: 1px #CBCACA solid;\r\n    background: #ffffff;\r\n\tbox-shadow: 1px 1px #CCC;\r\n\tz-index: 999999;\r\n}\r\n\r\n.table-dropdown-menu{\r\n\tlist-style: none;    \r\n    padding: 10px;   \r\n\tcolor: #2D2D2D;\r\n    font-weight: 600;\r\n}\r\n\r\n.table-dropdown-menu li{\r\n\tpadding: 5px;\r\n}\r\n\r\n.table-dropdown-menu li.disabled{\r\n\tcolor: #ccc!important;\r\n}\r\n\r\n.table-dropdown-menu li.disabled:hover{\r\n\tbackground-color: #fff;\r\n\tcursor: default;\r\n}\r\n\r\n.table-dropdown-menu li:hover{\r\n\tbackground-color: #F5F5F5;\r\n\tcursor: pointer;\r\n}\r\n\r\n.table-dropdown-menu hr{\r\n\tmargin: 10px 5px;\r\n}\r\n\r\n.share-button{\r\n   height: 25px !important;\r\n    padding: 2px 2px !important;\r\n    position: absolute;\r\n    font-size: 16px;\r\n    color: #CCC;\r\n    cursor: pointer;\r\n    margin-top: 2px;\r\n\tbackground-color: #ffffff;\r\n}\r\n\r\n.share-button:hover{\r\n\tcolor: #2D2D2D;\r\n}\r\n\r\n.form-link-modal .link{\r\n\tmargin-left: -22px;\r\n}\r\n\r\n.form-link-modal .open{\r\n\tmargin-left: -43px;\r\n}\r\n\r\n.pf-icon-star-fill{\r\n\tcolor: var(--accent-color);\r\n}\r\n\r\ninput.workspace-filter{\r\n\theight: 40px!important;\r\n\tborder: 1px solid #c5c5c5;\r\n\tborder-radius: 5px;\r\n\tdisplay: block;\r\n\tpadding: 0 4px 0 45px;\r\n\tfont-size: 13px!important;\r\n\tfont-family: Poppins;\r\n}\r\n\r\ninput.workspace-filter:hover{\r\n\tcursor: pointer;\r\n}\r\n\r\n.icon-right:hover{\r\n\tcursor: pointer;\r\n}\r\n\r\ninput.search-app, input.search-template {\t\r\n\twidth: 260px;\r\n\tbackground: transparent url('../../images/common/icons/icon_Search.svg') no-repeat 13px center;\t\r\n\tcursor: text!important;\r\n }\r\n\r\n .search-wrapper {\r\n\tposition: relative;\r\n\twidth: min-content;\r\n\tfloat: left;\r\n    margin-right: 5px;\r\n  }\r\n\r\n  .icon-right{\r\n\tposition: absolute;\r\n    right: 10px;\r\n    font-size: 15px;\r\n    font-weight: 600;\r\n    color: #939393;\r\n  }\r\n  \r\n  .clear-search, .clear-templ-search {\r\n\ttop: 8px;\r\n  }\r\n\r\n  .caret-down{\r\n\ttop: 16px;\r\n  }\r\n\r\n  .clear-search:hover, .clear-templ-search:hover{\r\n\tcursor: pointer;\r\n  }\r\n\r\n\r\n  input.filter-date-app {\r\n\twidth: 190px;\r\n\tbackground: transparent url('../../images/common/icons/calendar-filter.svg') no-repeat 13px center;\r\n }\r\n\r\n input.filter-status-app {\t\r\n\twidth: 120px;\r\n    padding: 0 10px;\r\n }\r\n\r\n .context-menu{\r\n\tborder-radius: 3px;\r\n\tborder: 1px solid #CDCDCD;\r\n\tbackground: #FFF;\r\n\tbox-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n\tposition: absolute;\r\n\tz-index: 99999999;\r\n\tleft: 5px;\r\n\ttop: 50px;\r\n\tpadding: 0 20px;\r\n }\r\n\r\n.filter-arrow {\r\n\tborder: solid #CDCDCD;\r\n    border-width: 0 1px 1px 0;\r\n    display: inline-block;\r\n    padding: 6px;\r\n    position: absolute;\r\n    top: -7px;\r\n    left: 12px;\r\n\tbackground-color: #fff;\r\n  }\r\n\r\n  .up {\r\n\ttransform: rotate(-135deg);\r\n\t-webkit-transform: rotate(-135deg);\r\n  }\r\n\r\n  .filter-button:hover{\r\n\tcursor: pointer;\r\n  }\r\n\r\n  .filter-button{\r\n\tborder-radius: 5px;\r\n    border: 1px solid #cccccc;\r\n    width: 190px;\r\n    height: 40px;\r\n    margin: 20px 0;\r\n    font-size: 13px;\r\n    text-align: center;\r\n    padding: 10px 0;\r\n    font-weight: 500;\r\n\tbackground: #FCFDFF;\r\n\tbox-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\t\r\n  }\r\n\r\n\r\n  .filter-button.set{\r\n\tbackground: #F89B3C;\r\n\tbox-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;\r\n\tfont-weight: 700;\r\n\tcolor: #ffffff;\r\n }\r\n\r\n\r\n\r\n#template-gallery{\r\n\tfont-family: Poppins;\r\n\tmargin: 15px;\r\n }\r\n\r\n .gallery-title{\r\n\tfont-weight: 500;\r\n\tfont-size: 22px;\r\n }\r\n\r\n .template-categories{\r\n\tlist-style: none;\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tpadding: 0 20px 0 0;\r\n\tmargin: 0;\r\n\tcolor: #2D2D2D;\r\n }\r\n\r\n .template-categories li{\r\n\tmargin: 10px 0;\r\n }\r\n\r\n .template-categories li a:hover{\r\n\tcursor: pointer;\r\n\ttext-decoration: none;\r\n\tcolor: #2D2D2D;\r\n }\r\n\r\n .template-categories .selected{\r\n\tborder-bottom: 2px solid #F89B3C;\r\n }\r\n\r\n .template-card{\r\n\tfont-size: 14px;\r\n\tmargin: 20px;\r\n\tposition: relative;\r\n\tfloat: left;\r\n\tpadding: 0 22px;\r\n }\r\n\r\n .template-card:hover{\r\n\t\r\n\tcursor: pointer;\r\n }\r\n\r\n .template-card .desktop{\r\n\twidth: 300px; \r\n\theight: 195px;\r\n\tborder-radius: 10px;\r\n\tborder: 6px solid #2D2D2D;\r\n\tbackground-color: red;\r\n\tbox-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n }\r\n\r\n .template-card .mobile{\r\n\twidth:90px; \r\n\ttop: 65px;\r\n    left: 260px;\r\n\theight: 150px;\r\n\tposition: absolute;\r\n\tbackground-color: #2d84a4;\r\n\tborder-radius: 10px;\r\n\tborder: 6px solid #2D2D2D;\r\n\tbox-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\r\n }\r\n\r\n .template-card .name{\r\n\tmargin: 15px 5px 5px 5px;\r\n    font-weight: bold;\r\n }\r\n\r\n .template-card .category{\r\n\tmargin: 5px;\r\n\tfont-size: 13px;\r\n }\r\n\r\n\r\n .browse-button{\r\n    margin: 0!important;\r\n    padding: 0!important;\r\n    width: 98%!important;\r\n    display: flex!important;\r\n\tcursor: pointer;\r\n }\r\n\r\n .browse-button label{\r\n\tmargin: 0!important;\r\n\tcursor: pointer;\r\n }\r\n\r\n .certificateExpired{\r\n\tcolor: red;\r\n}\r\n\r\n.truncate-text{\r\n\twhite-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n\twidth: 665px;\r\n}\r\n\r\n.refresh-wssource{\r\n\tfont-size:24px;\r\n}\r\n\r\n.refresh-wssource:hover{\r\n\tcursor:pointer;\r\n}\r\n\r\n/* --- Modal window maximize icons --- */\r\n.dialog-maximize-icon {\r\n    float: right;\r\n    margin-right: 5px; \r\n    cursor: pointer;\r\n\r\n    font-size: 1.1em;\r\n    margin-top: 2px;\r\n    padding: 2px;\r\n\r\n    color: #fff;\r\n}\r\n\r\n.dialog-maximize-icon:hover {\r\n    opacity: 0.8;\r\n}\r\n\r\n/* --- jqGrid Bootstrap Override --- */\r\n.jqgrid-table-override.ui-widget-content {\r\n    border: none;\r\n    background: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.jqgrid-table-override .ui-jqgrid-view {\r\n    border: none;\r\n\tfont-size: 13px;\r\n\tfont-family: Poppins;\r\n}\r\n\r\n/* Style the main data table  */\r\n.jqgrid-table-override .ui-jqgrid-bdiv .table {\r\n    border: 1px solid #dee2e6;\r\n}\r\n\r\n/* Style the header wrapper */\r\n.jqgrid-table-override .ui-jqgrid-hdiv {\r\n    border: 1px solid #dee2e6;\r\n    border-bottom: 2px solid #dee2e6;\r\n    background: #f8f9fa; \r\n}\r\n\r\n/* Style individual header cells */\r\n.jqgrid-table-override .ui-th-column {\r\n    border: none;\r\n    font-weight: 600;\r\n}\r\n\r\n.jqgrid-table-override .ui-jqgrid-bdiv {\r\n    overflow-x: hidden !important;\r\n}\r\n\r\n.jqgrid-table-override .ui-jqgrid-btable td {\r\n\twhite-space: pre-line!important;\r\n\toverflow-wrap: break-word;\r\n\theight: auto;\r\n\tvertical-align: middle;\r\n}\r\n\r\n.fix-input-width{\r\n\tpadding: 0 8px!important;\r\n}\r\n\r\n/* ========================================\r\n   Vector Database - Linked Apps\r\n   ======================================== */\r\n\r\n.vectordb-linked-apps-section {\r\n    margin-top: 15px;\r\n}\r\n\r\n.vectordb-linked-apps-list {\r\n    min-height: 40px;\r\n}\r\n\r\n.vectordb-loading,\r\n.vectordb-empty {\r\n    color: #999;\r\n    font-size: 12px;\r\n    padding: 10px 0;\r\n    font-style: italic;\r\n}\r\n\r\n.vectordb-linked-app-row {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 8px 10px;\r\n    border: 1px solid #e8e8e8;\r\n    border-radius: 4px;\r\n    margin-bottom: 4px;\r\n    background: #fff;\r\n}\r\n\r\n.vectordb-linked-app-row:hover {\r\n    background: #f9f9f9;\r\n}\r\n\r\n.vectordb-app-info {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n}\r\n\r\n.vectordb-app-name {\r\n    font-size: 12px;\r\n    font-weight: 600;\r\n    color: #333;\r\n}\r\n\r\n.vectordb-live-badge {\r\n    background: #E8F5E9;\r\n    color: #2E7D32;\r\n    font-size: 10px;\r\n    padding: 1px 6px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.vectordb-app-actions {\r\n    display: flex;\r\n    gap: 4px;\r\n}\r\n\r\n.vectordb-app-actions .btn {\r\n    font-size: 11px;\r\n}\r\n\r\n.vectordb-linked-apps-actions {\r\n    margin-top: 8px;\r\n}\r\n\r\n/* Vector DB Sync Progress */\r\n.vectordb-sync-progress {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    min-width: 180px;\r\n}\r\n.vectordb-sync-progress-bar-container {\r\n    flex: 1;\r\n    height: 8px;\r\n    background: #e8e8e8;\r\n    border-radius: 4px;\r\n    overflow: hidden;\r\n    min-width: 80px;\r\n}\r\n.vectordb-sync-progress-bar {\r\n    height: 100%;\r\n    background: #8eb934;\r\n    border-radius: 4px;\r\n    transition: width 0.3s ease;\r\n}\r\n.vectordb-sync-progress-text {\r\n    font-size: 11px;\r\n    color: #666;\r\n    white-space: nowrap;\r\n}\r\n.vectordb-sync-progress-text .glyphicon {\r\n    font-size: 10px;\r\n    margin-right: 2px;\r\n}\r\n.vectordb-sync-info {\r\n    font-size: 11px;\r\n    color: #999;\r\n    margin-left: 8px;\r\n}\r\n\r\n/* Danger Zone */\r\n.vectordb-danger-zone {\r\n    margin-top: 20px;\r\n    border: 1px solid #e0b4b4;\r\n    border-radius: 4px;\r\n    padding: 12px 16px;\r\n}\r\n.vectordb-danger-zone h2 {\r\n    color: #c9302c;\r\n    margin-top: 0;\r\n}\r\n.vectordb-danger-zone-item {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.vectordb-danger-zone-info p {\r\n    margin: 4px 0 0;\r\n    color: #777;\r\n    font-size: 12px;\r\n}\r\n\r\n/* Link App Dialog */\r\n.vectordb-link-dialog-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0,0,0,0.4);\r\n    z-index: 10000;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.vectordb-link-dialog {\r\n    background: #fff;\r\n    border-radius: 6px;\r\n    box-shadow: 0 4px 20px rgba(0,0,0,0.2);\r\n    width: 400px;\r\n    max-width: 90%;\r\n}\r\n\r\n.vectordb-link-dialog-header {\r\n    padding: 12px 16px;\r\n    border-bottom: 1px solid #e8e8e8;\r\n    font-size: 14px;\r\n}\r\n\r\n.vectordb-link-dialog-body {\r\n    padding: 16px;\r\n}\r\n\r\n.vectordb-link-dialog-body label {\r\n    font-size: 12px;\r\n    margin-bottom: 6px;\r\n    display: block;\r\n}\r\n\r\n.vectordb-link-dialog-body select {\r\n    width: 100%;\r\n}\r\n\r\n.vectordb-link-dialog-buttons {\r\n    padding: 12px 16px;\r\n    border-top: 1px solid #e8e8e8;\r\n    display: flex;\r\n    gap: 8px;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.glyphicon-spin {\r\n    animation: spin 1s infinite linear;\r\n}\r\n\r\n@keyframes spin {\r\n    from { transform: rotate(0deg); }\r\n    to { transform: rotate(360deg); }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
